<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title d-flex justify-content-between">
              <h4 class="text-truncate">{{ $t("overview.target-profil") }}</h4>
              <div
                class=""
                v-if="
                  id_user === target.id_analys ||
                  id_user === target.manager ||
                  user_type === 'superadmin' ||
                  user_type === 'admin' ||
                  user_type === 'vvip'
                "
              >
                <b-button
                  class="btn btn-sm mx-2"
                  variant="primary"
                  @click="editTarget(id)"
                  title="Edit"
                  ><i class="fas fa-edit"></i
                ></b-button>
                <router-link
                  :to="{
                    name: 'report',
                    params: {
                      id: id,
                      img: target.image_project,
                      tt: target.title,
                    },
                  }"
                  target="_blank"
                >
                  <b-button class="btn btn-sm" variant="primary"
                    ><i class="mdi mdi-badge-account-horizontal-outline"></i>
                    {{ $t("overview.report-analys") }}</b-button
                  >
                </router-link>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-8 d-flex align-items-center">
                <div class="">
                  <img
                    :src="urlimage + target.image_project"
                    class="avatar-xl rounded-circle mr-4"
                    role="button"
                    @click="showTargetImages(id)"
                  /><br />
                  <b-button
                    class="btn btn-sm mt-2"
                    variant="light"
                    @click="editTargetImages(id)"
                    v-if="
                      id_user === target.id_analys ||
                      id_user === target.manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                    ><i class="fas fa-image"></i>
                    {{ $t("overview.table.all.change-image") }}
                  </b-button>
                </div>
                <div class="">
                  <h4 class="">{{ target.title }}</h4>
                  <p class="py-1" v-if="target.category">
                    <span
                      class="badge text-white p-2"
                      :style="
                        'background-color: var(--' +
                        target.category.badge_color +
                        ')'
                      "
                    >
                      {{ target.category.category_name }}
                      <span v-if="template">
                        ( {{ template.template_name }} )
                      </span>
                    </span>
                  </p>
                  <div v-if="target.relation_profile">
                    <div
                      class="team-member d-inline-block"
                      v-for="(x, index) in JSON.parse(
                        '[' + target.relation_profile + ']'
                      )"
                      :key="index"
                    >
                      <a
                        :href="'/project/project-overview/' + x.id"
                        target="_blank"
                      >
                        <img
                          :title="x.name"
                          :src="urlimage + x.image"
                          class="rounded-circle avatar-xs m-1 shadow"
                          alt
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <apexchart
                  class="apex-charts"
                  type="radialBar"
                  height="200"
                  :options="gaugeOptions"
                  :series="gaugeSeries"
                ></apexchart>
              </div>
            </div>

            <h5
              class="font-size-15 mt-4"
              v-if="
                template.id_template == 2 ||
                template.id_template == 3 ||
                template.id_template == 4
              "
            >
              {{ $t("overview.table.all.address") }}
            </h5>
            <p
              class="text-muted"
              v-if="
                template.id_template == 2 ||
                template.id_template == 3 ||
                template.id_template == 4
              "
            >
              {{ target.address }}
            </p>
            <h5 class="font-size-15 mt-4">
              {{ $t("overview.table.all.description") }}
            </h5>
            <p class="text-muted text-justify">{{ target.description }}</p>

            <div class="row task-dates">
              <div class="col-lg-4">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-user mr-1 text-primary"></i> Analys
                  </h5>
                  <p class="text-muted mb-0">{{ username_analys }}</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-user mr-1 text-primary"></i> Manager
                  </h5>
                  <p class="text-muted mb-0">{{ username_manager }}</p>
                </div>
              </div>
            </div>
            <div class="row task-dates">
              <div class="col-lg-4">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar mr-1 text-primary"></i>
                    {{ $t("overview.table.all.created-at") }}
                  </h5>
                  <p class="text-muted mb-0">
                    {{ formatDate(target.created_at) }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar-check mr-1 text-primary"></i>
                    {{ $t("overview.table.all.updated-at") }}
                  </h5>
                  <p class="text-muted mb-0">
                    {{ formatDate(target.update_at) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card h-100">
          <Progress
            :id_target="id"
            :id_user="id_user"
            :id_template="template.id_template"
            :user_type="user_type"
            :manager="target.manager"
            :id_analys="target.id_analys"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">
              {{ $t("overview.table.all.private-data") }}
            </h4>
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab
                :title="$t('overview.table.citizen.citizen')"
                active
                v-if="template.id_template == 1 || template.id_template == 5"
              >
                <simplebar style="max-height: 50vh" class="mt-3">
                  <div v-if="target.citizen">
                    <table class="table-profile table text-left">
                      <thead>
                        <tr>
                          <td width="20%"><b>NIK</b></td>
                          <td width="80%">
                            <div class="row">
                              <div class="col-sm-6">
                                {{ citizen.nik }}
                              </div>
                              <div class="col-sm-6 text-right">
                                <b-dropdown
                                  class="chat-noti-dropdown active"
                                  right
                                  variant="white"
                                  v-if="
                                    id_user === target.id_analys ||
                                    id_user === target.manager ||
                                    user_type === 'superadmin' ||
                                    user_type === 'admin' ||
                                    user_type === 'vvip'
                                  "
                                >
                                  <template v-slot:button-content>
                                    <i
                                      class="bx bx-sm bx-dots-vertical-rounded"
                                    ></i>
                                  </template>
                                  <b-dropdown-item
                                    @click="editTargetCitizen(id)"
                                    class="text-danger"
                                    >{{
                                      $t("button.edit.text")
                                    }}</b-dropdown-item
                                  >
                                  <b-dropdown-item
                                    @click="
                                      deleteTargetCitizen(citizen.id_citizen)
                                    "
                                    class="text-danger"
                                    >{{
                                      $t("button.hapus.text")
                                    }}</b-dropdown-item
                                  >
                                </b-dropdown>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{ $t("overview.table.citizen.name") }}</b>
                          </td>
                          <td width="80%">{{ citizen.name }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{
                              $t("overview.table.citizen.birth-place")
                            }}</b>
                          </td>
                          <td width="80%">{{ citizen.birth_place }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{
                              $t("overview.table.citizen.date-of-birth")
                            }}</b>
                          </td>
                          <td width="80%">{{ citizen.date_of_birth }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{ $t("overview.table.citizen.gender") }}</b>
                          </td>
                          <td width="80%">{{ citizen.gender }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{ $t("overview.table.citizen.religion") }}</b>
                          </td>
                          <td width="80%">{{ citizen.religion }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{ $t("overview.table.citizen.profession") }}</b>
                          </td>
                          <td width="80%">{{ citizen.profession }}</td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{
                              $t("overview.table.citizen.nationality")
                            }}</b>
                          </td>
                          <td width="80%" class="text-uppercase">
                            {{ citizen.nationality }}
                          </td>
                        </tr>
                        <tr>
                          <td width="20%">
                            <b>{{ $t("overview.table.citizen.address") }}</b>
                          </td>
                          <td width="80%">{{ citizen.address }}</td>
                        </tr>
                      </thead>
                    </table>
                    <h5>{{ $t("overview.table.citizen.related-family") }}</h5>
                    <div class="table-responsive">
                      <table class="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>{{ $t("overview.table.citizen.name") }}</th>
                            <th>
                              {{ $t("overview.table.citizen.birth-place") }}
                            </th>
                            <th>{{ $t("overview.table.citizen.gender") }}</th>
                            <th>{{ $t("overview.table.citizen.address") }}</th>
                          </tr>
                        </thead>
                        <tbody v-if="family">
                          <tr
                            v-for="fams in family"
                            :key="fams._id"
                            v-if="fams._source.nik !== citizen.nik"
                          >
                            <th scope="row">
                              {{ fams._source.nama }}<br />
                              <small>NIK : {{ fams._source.nik }}</small
                              ><br />
                              <small>NKK : {{ fams._source.nkk }}</small>
                            </th>
                            <td>
                              {{ fams._source.tempat_lahir }},
                              {{ fams._source.tanggal_lahir }} <br />
                              <p>
                                {{ $t("overview.table.citizen.age") }} :
                                {{ countAge(fams._source.tanggal_lahir) }}
                              </p>
                            </td>
                            <td>
                              <span v-if="fams._source.jenis_kelamin == 1"
                                >L</span
                              >
                              <span v-else>P</span>
                            </td>
                            <td>{{ fams._source.alamat }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr
                            v-for="fams in family"
                            :key="fams._id"
                            v-if="fams._source.nik !== citizen.nik"
                          >
                            <th scope="row" colspan="4">
                              <p class="text-center">{{ $t("all.dnf") }}</p>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="div pt-5" v-else>
                    <p class="text-center">{{ $t("all.dnf") }}</p>
                    <p class="text-center">
                      <router-link to="/citizen">
                        <b-button
                          class="btn btn-sm"
                          variant="primary"
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                          ><i class="fas fa-search"></i>
                          {{ $t("overview.add-from-internet.text") }}</b-button
                        >
                      </router-link>
                    </p>
                  </div>
                </simplebar>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("overview.table.all.phone")
                  }}</span>
                </template>

                <simplebar style="max-height: 50vh" class="mt-3">
                  <table class="table table-centered">
                    <tbody v-if="target.private_data">
                      <tr>
                        <th width="30%">Email</th>
                        <td width="70%">
                          {{ private_data.email }}

                          <div
                            class="float-right"
                            v-if="
                              id_user === target.id_analys ||
                              id_user === target.manager ||
                              user_type === 'superadmin' ||
                              user_type === 'admin' ||
                              user_type === 'vvip'
                            "
                          >
                            <b-dropdown
                              class="chat-noti-dropdown active"
                              right
                              variant="white"
                            >
                              <template v-slot:button-content>
                                <i
                                  class="bx bx-sm bx-dots-vertical-rounded"
                                ></i>
                              </template>
                              <b-dropdown-item
                                @click="editTargetPrivate(id)"
                                class="text-danger"
                                >{{ $t("button.edit.text") }}</b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="delPrivateData(form.id_private_data)"
                                class="text-danger"
                                >{{ $t("button.hapus.text") }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.location") }}</th>
                        <td>{{ private_data.phone_location }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.phone") }}</th>
                        <td>{{ private_data.phone }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.carrier") }}</th>
                        <td>{{ private_data.phone_carrier }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.inter_format") }}</th>
                        <td>{{ private_data.phone_international_format }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.area") }}</th>
                        <td>{{ private_data.phone_area }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.local_format") }}</th>
                        <td>{{ private_data.phone_local_format }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.timezone") }}</th>
                        <td>{{ private_data.phone_timezone }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.country_code") }}</th>
                        <td>{{ private_data.phone_country_code }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("overview.table.all.possibility") }}</th>
                        <td>
                          {{
                            private_data.phone_possibility ? "True" : "False"
                          }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="text-secondary">
                        <p class="text-center pt-5">
                          {{ $t("overview.table.all.dnf") }}
                        </p>
                        <p class="text-center">
                          <b-button
                            class="btn btn-sm"
                            variant="primary"
                            v-if="
                              id_user === target.id_analys ||
                              id_user === target.manager ||
                              user_type === 'superadmin' ||
                              user_type === 'admin' ||
                              user_type === 'vvip'
                            "
                            @click="addTargetPrivate()"
                            ><i class="fas fa-user-plus"></i>
                            {{ $t("button.add.text") }}</b-button
                          >
                        </p>
                      </tr>
                    </tbody>
                  </table>
                </simplebar>
              </b-tab>
              <b-tab
                v-if="template.id_template == 1 || template.id_template == 5"
              >
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Tags</span>
                </template>
                <div v-if="tags != 0">
                  <p class="font-weight-bold">
                    Total {{ JSON.parse(tags).length }} Tags Found
                  </p>
                  <div
                    class="row custom-scroll"
                    style="max-height: 400px !important; overflow-y: auto"
                  >
                    <div
                      class="col-lg-3 my-auto pb-2"
                      v-for="(tg, index) in JSON.parse(tags)"
                      :key="index"
                    >
                      <b-button variant="outline-primary btn-block">{{
                        tg
                      }}</b-button>
                    </div>
                  </div>
                </div>
                <div v-else class="mt-3">
                  <p class="text-center pt-5">
                    {{ $t("overview.table.all.dnf") }}
                  </p>
                  <p class="text-center">
                    <router-link to="/phone-search"
                      ><b-button
                        class="btn btn-sm"
                        variant="primary"
                        v-if="
                          id_user === target.id_analys ||
                          id_user === target.manager ||
                          user_type === 'superadmin' ||
                          user_type === 'admin' ||
                          user_type === 'vvip'
                        "
                        ><i class="fas fa-search"></i>
                        {{ $t("overview.add-from-internet.text") }}</b-button
                      ></router-link
                    >
                  </p>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">
              {{ $t("overview.social-media") }}
            </h4>
            <b-tabs
              content-class="crypto-buy-sell-nav-content"
              nav-class="nav-tabs-custom"
            >
              <b-tab title="Twitter">
                <div class="card mt-3">
                  <table
                    class="table-profile table text-left"
                    v-if="target.twitter"
                  >
                    <thead>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.avatar") }}</b>
                        </td>
                        <td width="60%">
                          <div class="row">
                            <div class="col-sm-6">
                              <img
                                :src="twitter.avatar"
                                class="rounded-circle avatar-xs"
                                alt
                              />
                            </div>
                            <div
                              class="col-sm-6 text-right"
                              v-if="
                                id_user === target.id_analys ||
                                id_user === target.manager ||
                                user_type === 'superadmin' ||
                                user_type === 'admin' ||
                                user_type === 'vvip'
                              "
                            >
                              <b-dropdown
                                class="chat-noti-dropdown active"
                                right
                                variant="white"
                              >
                                <template v-slot:button-content>
                                  <i
                                    class="bx bx-sm bx-dots-vertical-rounded"
                                  ></i>
                                </template>
                                <b-dropdown-item
                                  ><router-link
                                    :to="{
                                      name: 'twitter-view',
                                      params: { id: twitter.account },
                                    }"
                                    >View Detail</router-link
                                  ></b-dropdown-item
                                >
                                <b-dropdown-item
                                  @click="deleteTargetTwitter(id)"
                                  class="text-danger"
                                  >{{
                                    $t("button.hapus.text")
                                  }}</b-dropdown-item
                                >
                              </b-dropdown>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.account") }}</b>
                        </td>
                        <td width="80%">{{ twitter.account }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.screen_name") }}</b>
                        </td>
                        <td width="80%">{{ twitter.name }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.follows") }}</b>
                        </td>
                        <td width="80%">{{ twitter.followers }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.followed") }}</b>
                        </td>
                        <td width="80%">{{ twitter.following }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.join_at") }}</b>
                        </td>
                        <td width="80%">{{ twitter.join_at }}</td>
                      </tr>
                      <tr>
                        <td width="20%"><b>Detail</b></td>
                        <td width="80%">
                          <router-link
                            :to="{
                              name: 'twitter-view',
                              params: { id: twitter.account },
                            }"
                            >{{ $t("overview.view-detail.text") }}</router-link
                          >
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <div class="div" v-else>
                    <p class="text-center pt-5">
                      {{ $t("overview.table.all.dnf") }}
                    </p>
                    <div
                      v-if="
                        id_user === target.id_analys ||
                        id_user === target.manager ||
                        user_type === 'superadmin' ||
                        user_type === 'admin' ||
                        user_type === 'vvip'
                      "
                    >
                      <p class="text-center pt-1 pb-5">
                        <b-button
                          class="btn btn-sm mr-1"
                          variant="primary"
                          @click="addTwitter(id)"
                          ><i class="fas fa-user-plus"></i>
                          {{ $t("overview.add-from-database.text") }}</b-button
                        ><b-button
                          class="btn btn-sm"
                          variant="primary"
                          @click="addTwitterSearch(id)"
                          ><i class="fas fa-search"></i>
                          {{ $t("overview.add-from-internet.text") }}</b-button
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Instagram">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card mt-3">
                      <table
                        class="table-profile table text-left"
                        v-if="target.instagram"
                      >
                        <thead>
                          <tr>
                            <td width="20%">
                              <b>{{
                                $t("overview.table.instagram.picture")
                              }}</b>
                            </td>
                            <td width="60%">
                              <div class="row">
                                <div class="col-sm-6" v-if="instagram.picture">
                                  <img
                                    :src="instagram.picture"
                                    class="rounded-circle avatar-xs"
                                    alt
                                  />
                                </div>
                                <div class="col-sm-6" v-else>
                                  <img
                                    src="@/assets/images/users/avatar-10.jpg"
                                    class="rounded-circle avatar-xs"
                                    alt
                                  />
                                </div>
                                <div
                                  class="col-sm-6 text-right"
                                  v-if="
                                    id_user === target.id_analys ||
                                    id_user === target.manager ||
                                    user_type === 'superadmin' ||
                                    user_type === 'admin' ||
                                    user_type === 'vvip'
                                  "
                                >
                                  <b-dropdown
                                    class="chat-noti-dropdown active"
                                    right
                                    variant="white"
                                  >
                                    <template v-slot:button-content>
                                      <i
                                        class="bx bx-sm bx-dots-vertical-rounded"
                                      ></i>
                                    </template>
                                    <b-dropdown-item
                                      ><router-link
                                        :to="{
                                          name: 'instagram-view',
                                          params: { id: instagram.account },
                                        }"
                                        >View Detail</router-link
                                      ></b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="deleteTargetInstagram(id)"
                                      class="text-danger"
                                      >{{
                                        $t("button.hapus.text")
                                      }}</b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td width="20%">
                              <b>{{ $t("overview.table.all.account") }}</b>
                            </td>
                            <td width="80%">{{ instagram.account }}</td>
                          </tr>
                          <tr>
                            <td width="20%">
                              <b>{{
                                $t("overview.table.instagram.full-name")
                              }}</b>
                            </td>
                            <td width="80%">{{ instagram.full_name }}</td>
                          </tr>
                          <tr>
                            <td width="20%">
                              <b>{{ $t("overview.table.instagram.bio") }}</b>
                            </td>
                            <td width="80%">{{ instagram.bio }}</td>
                          </tr>
                          <tr>
                            <td width="20%">
                              <b>{{ $t("overview.table.all.followed") }}</b>
                            </td>
                            <td width="80%">{{ instagram.following }}</td>
                          </tr>
                          <tr>
                            <td width="20%">
                              <b>{{ $t("overview.table.all.follows") }}</b>
                            </td>
                            <td width="80%">{{ instagram.followers }}</td>
                          </tr>
                          <tr>
                            <td width="20%"><b>Media</b></td>
                            <td width="80%">{{ instagram.media }}</td>
                          </tr>
                          <tr>
                            <td width="20%"><b>Category</b></td>
                            <td width="80%">{{ instagram.category_name }}</td>
                          </tr>
                          <tr>
                            <td width="20%"><b>Detail</b></td>
                            <td width="80%">
                              <router-link
                                :to="{
                                  name: 'instagram-view',
                                  params: { id: instagram.account },
                                }"
                                >{{
                                  $t("overview.view-detail.text")
                                }}</router-link
                              >
                            </td>
                          </tr>
                        </thead>
                      </table>
                      <div class="div" v-else>
                        <p class="text-center pt-5">
                          {{ $t("overview.table.all.dnf") }}
                        </p>
                        <div
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                        >
                          <p class="text-center pt-1 pb-5">
                            <b-button
                              class="btn btn-sm mr-1"
                              variant="primary"
                              @click="addInstagram(id)"
                              ><i class="fas fa-user-plus"></i>
                              {{
                                $t("overview.add-from-database.text")
                              }}</b-button
                            ><b-button
                              class="btn btn-sm"
                              variant="primary"
                              @click="addInstagramSearch(id)"
                              ><i class="fas fa-search"></i>
                              {{
                                $t("overview.add-from-internet.text")
                              }}</b-button
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Telegram">
                <div class="card">
                  <table
                    class="table-profile table text-left mt-3"
                    v-if="target.telegram"
                  >
                    <thead>
                      <tr class="mt-2">
                        <td width="20%">
                          <b>{{ $t("overview.table.all.avatar") }}</b>
                        </td>
                        <td width="60%">
                          <div class="row">
                            <div class="col-sm-6">
                              <img
                                src="@/assets/images/users/avatar-10.jpg"
                                class="rounded-circle avatar-xs"
                                alt
                              />
                            </div>
                            <div
                              class="col-sm-6 text-right"
                              v-if="
                                id_user === target.id_analys ||
                                id_user === target.manager ||
                                user_type === 'superadmin' ||
                                user_type === 'admin' ||
                                user_type === 'vvip'
                              "
                            >
                              <b-dropdown
                                class="chat-noti-dropdown active"
                                right
                                variant="white"
                              >
                                <template v-slot:button-content>
                                  <i
                                    class="bx bx-sm bx-dots-vertical-rounded"
                                  ></i>
                                </template>
                                <b-dropdown-item
                                  class="text-primary"
                                  @click="editTargetTelegram(id)"
                                  >{{ $t("button.edit.text") }}</b-dropdown-item
                                >
                                <b-dropdown-item
                                  class="text-danger"
                                  @click="
                                    deleteTelegramData(telegram.id_telegram)
                                  "
                                  >{{
                                    $t("button.hapus.text")
                                  }}</b-dropdown-item
                                >
                              </b-dropdown>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.username") }}</b>
                        </td>
                        <td width="80%">{{ telegram.account }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.first_name") }}</b>
                        </td>
                        <td width="80%">{{ telegram.first_name }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.last_name") }}</b>
                        </td>
                        <td width="80%">{{ telegram.last_name }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.phone") }}</b>
                        </td>
                        <td width="80%">{{ telegram.phone }}</td>
                      </tr>
                      <tr>
                        <td width="20%">
                          <b>{{ $t("overview.table.all.list-group") }}</b>
                        </td>
                        <td width="80%">
                          <div v-if="telegram.group_list">
                            <span
                              v-for="(list, index) in JSON.parse(
                                telegram.group_list
                              )"
                              :key="index"
                            >
                              <router-link
                                :to="{
                                  name: 'group-view',
                                  params: { id: list._id },
                                }"
                                class="xbadge btn btn-light mb-1 mr-0 btn-sm text-secondary border-top-secondary"
                                >{{ list._id }} </router-link
                              ><router-link
                                :to="{
                                  name: 'member-chat',
                                  params: {
                                    id: list._id,
                                    name: telegram.account,
                                  },
                                }"
                                class="xbadge btn btn-light mr-2 mb-1 btn-sm text-secondary"
                              >
                                <i class="bx bx-message"></i>
                              </router-link>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <div class="div" v-else>
                    <div class="pt-2">
                      <p class="text-center pt-5">
                        {{ $t("overview.table.all.dnf") }}
                      </p>
                      <p class="text-center pt-1 pb-5">
                        <b-button
                          class="btn btn-sm mr-1"
                          variant="primary"
                          @click="addTargetTelegram"
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                          ><i class="fas fa-user-plus"></i>
                          {{ $t("button.add.text") }}</b-button
                        >

                        <b-button
                          class="btn btn-sm"
                          variant="primary"
                          @click="addTargetTelegramPhone"
                          v-if="
                            id_user === target.id_analys ||
                            id_user === target.manager ||
                            user_type === 'superadmin' ||
                            user_type === 'admin' ||
                            user_type === 'vvip'
                          "
                          ><i class="fas fa-search"></i>
                          {{ $t("button.all-search-number") }}</b-button
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                :title="$t('overview.other-info')"
                v-if="template.id_template == 1 || template.id_template == 5"
              >
                <MediaHunt :id_target="id"></MediaHunt>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div
        class="row mt-3"
        v-if="template.id_template == 1 || template.id_template == 5"
      >
        <RelationImage
          :id_target="id"
          :id_twitter="twitter != null ? twitter.account : null"
          :id_instagram="instagram != null ? instagram.user_id : null"
          :id_user="id_user"
          :user_type="user_type"
          :manager="target.manager"
          :id_analys="target.id_analys"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card h-100">
          <Advanced
            :id_target="id"
            :id_template="template.id_template"
            :id_user="id_user"
            :user_type="user_type"
            :manager="target.manager"
            :id_analys="target.id_analys"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-12">
        <News
          :id_target="id"
          :twitter="twitter"
          :instagram="instagram"
          :id_user="id_user"
          :user_type="user_type"
          :manager="target.manager"
          :id_analys="target.id_analys"
        />
      </div>
    </div>

    <div class="row mb-4">
      <NewsAnalytic :id_target="id" />
    </div>

    <div class="row">
      <Sna
        :nametarget="target.title"
        :imgtarget="target.image_project"
        :idtarget="id"
        :twitter="twitter"
        :id_user="id_user"
        :user_type="user_type"
        :manager="target.manager"
        :id_analys="target.id_analys"
      />
    </div>

    <!-- edit target -->
    <b-modal
      ref="ref-modal-edit"
      :id="'modal-edit' + id"
      centered
      :title="$t('button.update.text') + ' Target'"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="updateTarget($event, id)"
      @shown="refreshSlider"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01"
              >{{ $t("overview.table.all.title") }}
            </label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.title')"
              v-model="form.title"
              :class="{ 'is-invalid': submitted && $v.form.title.$error }"
            />
            <div
              v-if="submitted && $v.form.title.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.title.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01"
              >{{ $t("overview.table.all.description") }}
            </label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.description')"
              v-model="form.description"
              :class="{ 'is-invalid': submitted && $v.form.description.$error }"
            />
            <div
              v-if="submitted && $v.form.description.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.description.required">{{
                $t("form.error.text")
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.category")
            }}</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="form.id_category"
            >
              <option
                v-for="cat in categoryAll"
                :key="cat.id_category"
                :value="cat.id_category"
              >
                {{ cat.category_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01"
              >{{ $t("overview.table.all.score") }}
            </label>
            <vue-slide-bar
              class="p-0 pt-4"
              ref="slidescore"
              v-model="form.category_score"
              :min="0"
              :max="100"
            />
            <b-button-group class="mt-1 btn-group-sm">
              <b-button variant="secondary" @click="form.category_score -= 1">
                <i class="fas fa-minus"></i>
              </b-button>
              <b-form-input
                ref="input-size"
                size="sm"
                for="text"
                :value="form.category_score"
                maxlength="3"
                v-model="form.category_score"
                style="width: 40px"
              ></b-form-input>
              <b-button variant="secondary" @click="form.category_score += 1">
                <i class="fas fa-plus"></i>
              </b-button>
            </b-button-group>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mb-3">
            <label for="validationCustom01"
              >{{ $t("wizard.form.label.relation_profile") }}
              <span><small>(Max. 6 profile)</small></span>
            </label>
            <b-form-tags
              id="tags-with-dropdown"
              v-model="relation"
              no-outer-focus
            >
              <template v-slot="{ tags, disabled, addTag, removeTag }">
                <ul
                  v-if="tags.length > 0"
                  class="list-inline d-inline-block mb-2"
                >
                  <li
                    v-for="(tag, index) in tags"
                    :key="index"
                    class="list-inline-item mb-2"
                  >
                    <b-form-tag
                      @remove="removeTag(tag)"
                      :title="JSON.parse(tag).name"
                      :disabled="disabled"
                      variant="primary"
                    >
                      <div class="team">
                        <a
                          href="javascript: void(0);"
                          class="team-member d-inline-block"
                        >
                          <img
                            :src="urlimage + JSON.parse(tag).image"
                            class="rounded-circle avatar-xs m-1"
                            alt
                          />
                        </a>
                      </div>
                      {{ JSON.parse(tag).name }}
                    </b-form-tag>
                  </li>
                </ul>

                <b-dropdown
                  size="sm"
                  variant="outline-secondary"
                  block
                  menu-class="w-100"
                  :disabled="relation.length < 6 ? false : true"
                >
                  <template #button-content>
                    {{ $t("wizard.form.button.relation_profile") }}
                  </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}">
                    <b-form-group
                      :label="$t('wizard.form.label.relation_profile_search')"
                      label-for="tag-search-input"
                      label-cols-md="auto"
                      class="mb-0"
                      label-size="sm"
                      :description="searchDesc"
                      :disabled="disabled"
                    >
                      <b-form-input
                        ref="in_relation"
                        v-on:keyup="
                          searching != '' ? (show = true) : (show = false)
                        "
                        v-model="searching"
                        id="tag-search-input"
                        type="search"
                        size="sm"
                        autocomplete="off"
                      ></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    v-show="show"
                    v-for="(option, index) in availableOptions"
                    :key="index"
                    @click="onOptionClick({ option, addTag })"
                  >
                    {{ option.name }}
                  </b-dropdown-item-button>
                  <b-dropdown-text v-if="availableOptions.length === 0">
                    {{ $t("wizard.form.validation.not_match2") }}
                  </b-dropdown-text>
                </b-dropdown>
              </template>
            </b-form-tags>
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="
            template.id_template == 4 ||
            template.id_template == 2 ||
            template.id_template == 3
          "
        >
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.address")
            }}</label>
            <textarea
              rows="7"
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.address')"
              v-model="form.address"
            >
            </textarea>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- change image -->
    <b-modal
      ref="ref-modal-edit"
      :id="'modal-edit-images' + id"
      centered
      :title="$t('button.update.text')"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="updateTargetImages($event, id)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group text-center">
            <img
              :src="urlimage + target.image_project"
              class="avatar-xl rounded-circle mr-4"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01"
              >{{ $t("overview.table.all.new-image") }}
            </label>
            <b-form-file
              :state="true"
              :placeholder="$t('overview.table.all.choose')"
              :drop-placeholder="$t('overview.table.all.drop')"
              @change="ImageTarget"
              accept="image/*"
            ></b-form-file>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- edit target private data -->
    <b-modal
      v-if="target.private_data"
      size="lg"
      ref="ref-modal-edit"
      :id="'modal-edit-private' + id"
      centered
      :title="
        $t('button.update.text') + ' ' + $t('overview.table.all.private-data')
      "
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="editPrivateData($event, private_data.id_private_data)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">Email</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="email"
              v-model="private_data_add.email"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("phone.phone-number")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              v-on:input="acceptNumber(private_data_add.phone)"
              v-model="private_data_add.phone"
            />
            <b-button
              @click="searchPhone"
              class="btn btn-sm mt-1"
              variant="primary"
              >Search</b-button
            >
          </div>
        </div>
        <div class="col-md-12" v-if="!search_phone[0].international_format">
          <div>
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.international-format")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light"
                    :value="private_data.phone_international_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.local-format")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_local_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.country-code")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_country_code"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.location")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_location"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.carrier")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_carrier"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{ $t("phone.area") }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_area"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.timezone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_timezone"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.possibility")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="private_data.phone_possibility"
                    readonly
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-else>
          <div v-for="result in search_phone" :key="result.index">
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.international-format")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light"
                    :value="result.international_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.local-format")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.local_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01"
                    >{{ $t("phone.country-code") }}
                  </label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.country_code"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.location")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.location"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.carrier")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.carrier"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{ $t("phone.area") }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.area"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.timezone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.timezone"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.possibility")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.possibility"
                    readonly
                  />
                </p>
              </div>
            </div>

            <hr v-if="result_telegram.tag" />
            <div class="row" v-if="result_telegram.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_telegram.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_telegram.tag"
                    readonly
                  />
                </p>
              </div>
            </div>

            <hr v-if="result_tokped.tag" />
            <div class="row" v-if="result_tokped.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_tokped.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_tokped.tag"
                    readonly
                  />
                </p>
              </div>
            </div>

            <hr v-if="result_fb.tag" />
            <div class="row" v-if="result_fb.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_fb.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_fb.tag"
                    readonly
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- edit target twitter -->
    <b-modal
      v-if="target.twitter"
      ref="ref-modal-edit"
      :id="'modal-edit-twitter' + id"
      centered
      :title="$t('button.update.text') + ' Twitter'"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="editTwitter($event, twitter.id_twitter)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.account")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.account')"
              v-model="twitter.account"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.screen_name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.screen_name')"
              v-model="twitter.screen_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.follows")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.follows')"
              v-model="twitter.followers"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.followed")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.followed')"
              v-model="twitter.following"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.join_at")
            }}</label>
            <input
              id="validationCustom01"
              type="date"
              class="form-control"
              v-model="twitter.join_at"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <!-- edit target instagram -->
    <b-modal
      v-if="target.instagram"
      ref="ref-modal-edit"
      :id="'modal-edit-instagram' + id"
      centered
      :title="$t('button.update.text') + ' Instagram'"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="editInstagram($event, instagram.id_instagram)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.account")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.account')"
              v-model="instagram.account"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.instagram.full-name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.instagram.full-name')"
              v-model="instagram.full_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.instagram.bio")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.instagram.bio')"
              v-model="instagram.bio"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.followed")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.followed')"
              v-model="instagram.following"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.follows")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.follows')"
              v-model="instagram.followers"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">Media</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="media"
              v-model="instagram.media"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add edit target telegram -->
    <b-modal
      ref="ref-modal-edit"
      :id="'modal-add-telegram'"
      centered
      :title="$t('button.add.text') + ' Telegram'"
      title-class="font-18"
      :ok-title="$t('button.add.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="addTelegram($event)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01"
              >{{ $t("overview.table.all.username") }}
              <span class="text-primary">*Contoh: KangKuman</span>
            </label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="username"
              v-model="telegram_add.account"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.first_name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.first_name')"
              v-model="telegram_add.first_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.last_name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.last_name')"
              v-model="telegram_add.last_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.list-group")
            }}</label>
            <div class="row">
              <div class="col-sm-7">
                <div v-if="group_result_not_found" class="text-secondary">
                  {{ group_result_not_found }}
                </div>
                <div v-if="!loadingtele">
                  <span v-if="group_result">
                    <span v-for="(list, index) in group_result" :key="index"
                      ><router-link
                        to="#"
                        class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                        >{{ list._id }}
                      </router-link>
                    </span>
                  </span>
                </div>
                <div v-if="telegram">
                  <span v-if="telegram.group_list">
                    <span
                      v-for="(list, index) in JSON.parse(telegram.group_list)"
                      :key="index"
                      ><router-link
                        :to="{ name: 'group-view', params: { id: list._id } }"
                        class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                        >{{ list._id }}
                      </router-link> </span
                    >..
                  </span>
                </div>
                <div v-if="loadingtele">
                  <b-spinner label="Loading ..." small></b-spinner>
                </div>
              </div>
              <div class="col-sm-5 text-right">
                <b-button
                  class="btn btn-sm"
                  variant="primary"
                  @click="searchGroupTele(telegram_add.account)"
                  ><span v-if="!loadingtele"
                    ><i class="fas fa-search"></i> Search by Username
                  </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.phone")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="phone"
              v-model="telegram_add.phone"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="ref-modal-edit"
      :id="'modal-add-telegram-phone'"
      centered
      :title="$t('button.add.text') + ' Telegram'"
      title-class="font-18"
      :ok-title="$t('button.add.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="addTelegram($event)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.phone")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="628.."
              v-on:input="acceptNumberTele(telegram_add.phone)"
              v-model="telegram_add.phone"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.list-group")
            }}</label>
            <div class="row">
              <div class="col-sm-7 mb-2">
                <div v-if="group_result_not_found" class="text-secondary">
                  {{ group_result_not_found }}
                </div>
                <div v-if="!loadingtele">
                  <span v-if="group_result">
                    <span v-for="(list, index) in group_result" :key="index"
                      ><router-link
                        to="#"
                        class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                        >{{ list._id }}
                      </router-link>
                    </span>
                  </span>
                </div>
                <div v-if="telegram">
                  <span v-if="telegram.group_list">
                    <span
                      v-for="(list, index) in JSON.parse(telegram.group_list)"
                      :key="index"
                      ><router-link
                        :to="{ name: 'group-view', params: { id: list._id } }"
                        class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                        >{{ list._id }}
                      </router-link> </span
                    >..
                  </span>
                </div>
                <div v-if="loadingtele">
                  <b-spinner label="Loading ..." small></b-spinner>
                </div>
              </div>
              <div class="col-sm-5 mb-2 text-right">
                <b-button
                  class="btn btn-sm"
                  variant="primary"
                  @click="SearchPhoneTele(telegram_add.phone)"
                  ><span v-if="!loadingtele"
                    ><i class="fas fa-search"></i> Search by Phone
                  </span>
                </b-button>
              </div>
              <div class="col-md-12" v-if="telegram_add.username">
                <div class="form-group">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.username")
                  }}</label>
                  <input
                    id="validationCustom01"
                    type="text"
                    class="form-control"
                    placeholder="username"
                    v-model="telegram_add.account"
                  />
                </div>
              </div>
              <div class="col-md-12" v-if="telegram_add.first_name">
                <div class="form-group">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.first_name")
                  }}</label>
                  <input
                    id="validationCustom01"
                    type="text"
                    class="form-control"
                    :placeholder="$t('overview.table.all.first_name')"
                    v-model="telegram_add.first_name"
                  />
                </div>
              </div>
              <div class="col-md-12" v-if="telegram_add.last_name">
                <div class="form-group">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.last_name")
                  }}</label>
                  <input
                    id="validationCustom01"
                    type="text"
                    class="form-control"
                    :placeholder="$t('overview.table.all.last_name')"
                    v-model="telegram_add.last_name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-if="target.telegram"
      ref="ref-modal-edit"
      :id="'modal-edit-telegram' + id"
      centered
      :title="$t('button.update.text') + ' Telegram'"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="editTelegram($event, telegram.id_telegram)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.phone")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              placeholder="phone"
              v-model="telegram.phone"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.first_name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.first_name')"
              v-model="telegram.first_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.last_name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.all.last_name')"
              v-model="telegram.last_name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.all.list-group")
            }}</label>
            <div class="row">
              <div class="col-sm-7">
                <div v-if="group_result_not_found" class="text-secondary">
                  {{ group_result_not_found }}
                </div>
                <div v-if="!loadingtele">
                  <span v-for="(list, index) in group_result" :key="index"
                    ><router-link
                      to="#"
                      class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                      >{{ list._id }}
                    </router-link>
                  </span>
                </div>
                <div
                  v-if="
                    telegram.group_list &&
                    !group_result &&
                    !group_result_not_found
                  "
                >
                  <span
                    v-for="(list, index) in JSON.parse(telegram.group_list)"
                    :key="index"
                    ><router-link
                      :to="{ name: 'group-view', params: { id: list._id } }"
                      class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                      >{{ list._id }}
                    </router-link>
                  </span>
                </div>
                <div v-if="loadingtele">
                  <b-spinner label="Loading ..." small></b-spinner>
                </div>
              </div>
              <!-- <div class="col-sm-5 text-right">
                <b-button
                  class="btn btn-sm"
                  variant="primary"
                  @click="searchGroupTele(telegram.account)"
                  ><span v-if="!loadingtele"
                    ><i class="fas fa-search"></i> Search by Username
                  </span>
                </b-button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- edit target citizen -->
    <b-modal
      v-if="target.citizen"
      ref="ref-modal-edit"
      :id="'modal-edit-citizen' + id"
      centered
      :title="$t('button.update.text') + ' Citizen'"
      title-class="font-18"
      :ok-title="$t('button.update.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="editCitizen($event, citizen.id_citizen)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">NIK</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control bg-light"
              v-model="citizen.nik"
              readonly
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.name")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.citizen.name')"
              v-model="citizen.name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.birth-place")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.citizen.birth-place')"
              v-model="citizen.birth_place"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.date-of-birth")
            }}</label>
            <input
              id="validationCustom01"
              type="date"
              class="form-control"
              :placeholder="$t('overview.table.citizen.date-of-birth')"
              v-model="citizen.date_of_birth"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.gender")
            }}</label>
            <select
              name="gender"
              id=""
              class="form-control"
              v-model="citizen.gender"
            >
              <option value="L">L</option>
              <option value="P">P</option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.religion")
            }}</label>
            <select
              name="religion"
              id=""
              class="form-control"
              v-model="citizen.religion"
            >
              <option value="Islam">Islam</option>
              <option value="Kristen">Kristen</option>
              <option value="Khatolik">Katholik</option>
              <option value="Budha">Budha</option>
              <option value="Hindu">Hindu</option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.marriage-status")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.citizen.marriage_status')"
              v-model="citizen.marriage_status"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.profession")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.citizen.profession')"
              v-model="citizen.profession"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.nationality")
            }}</label>
            <select
              name="nationality"
              class="form-control"
              v-model="citizen.nationality"
            >
              <option value="">-- Select One --</option>
              <option value="afghan">Afghan</option>
              <option value="albanian">Albanian</option>
              <option value="algerian">Algerian</option>
              <option value="american">American</option>
              <option value="andorran">Andorran</option>
              <option value="angolan">Angolan</option>
              <option value="antiguans">Antiguans</option>
              <option value="argentinean">Argentinean</option>
              <option value="armenian">Armenian</option>
              <option value="australian">Australian</option>
              <option value="austrian">Austrian</option>
              <option value="azerbaijani">Azerbaijani</option>
              <option value="bahamian">Bahamian</option>
              <option value="bahraini">Bahraini</option>
              <option value="bangladeshi">Bangladeshi</option>
              <option value="barbadian">Barbadian</option>
              <option value="barbudans">Barbudans</option>
              <option value="batswana">Batswana</option>
              <option value="belarusian">Belarusian</option>
              <option value="belgian">Belgian</option>
              <option value="belizean">Belizean</option>
              <option value="beninese">Beninese</option>
              <option value="bhutanese">Bhutanese</option>
              <option value="bolivian">Bolivian</option>
              <option value="bosnian">Bosnian</option>
              <option value="brazilian">Brazilian</option>
              <option value="british">British</option>
              <option value="bruneian">Bruneian</option>
              <option value="bulgarian">Bulgarian</option>
              <option value="burkinabe">Burkinabe</option>
              <option value="burmese">Burmese</option>
              <option value="burundian">Burundian</option>
              <option value="cambodian">Cambodian</option>
              <option value="cameroonian">Cameroonian</option>
              <option value="canadian">Canadian</option>
              <option value="cape verdean">Cape Verdean</option>
              <option value="central african">Central African</option>
              <option value="chadian">Chadian</option>
              <option value="chilean">Chilean</option>
              <option value="chinese">Chinese</option>
              <option value="colombian">Colombian</option>
              <option value="comoran">Comoran</option>
              <option value="congolese">Congolese</option>
              <option value="costa rican">Costa Rican</option>
              <option value="croatian">Croatian</option>
              <option value="cuban">Cuban</option>
              <option value="cypriot">Cypriot</option>
              <option value="czech">Czech</option>
              <option value="danish">Danish</option>
              <option value="djibouti">Djibouti</option>
              <option value="dominican">Dominican</option>
              <option value="dutch">Dutch</option>
              <option value="east timorese">East Timorese</option>
              <option value="ecuadorean">Ecuadorean</option>
              <option value="egyptian">Egyptian</option>
              <option value="emirian">Emirian</option>
              <option value="equatorial guinean">Equatorial Guinean</option>
              <option value="eritrean">Eritrean</option>
              <option value="estonian">Estonian</option>
              <option value="ethiopian">Ethiopian</option>
              <option value="fijian">Fijian</option>
              <option value="filipino">Filipino</option>
              <option value="finnish">Finnish</option>
              <option value="french">French</option>
              <option value="gabonese">Gabonese</option>
              <option value="gambian">Gambian</option>
              <option value="georgian">Georgian</option>
              <option value="german">German</option>
              <option value="ghanaian">Ghanaian</option>
              <option value="greek">Greek</option>
              <option value="grenadian">Grenadian</option>
              <option value="guatemalan">Guatemalan</option>
              <option value="guinea-bissauan">Guinea-Bissauan</option>
              <option value="guinean">Guinean</option>
              <option value="guyanese">Guyanese</option>
              <option value="haitian">Haitian</option>
              <option value="herzegovinian">Herzegovinian</option>
              <option value="honduran">Honduran</option>
              <option value="hungarian">Hungarian</option>
              <option value="icelander">Icelander</option>
              <option value="indian">Indian</option>
              <option value="indonesian">Indonesian</option>
              <option value="iranian">Iranian</option>
              <option value="iraqi">Iraqi</option>
              <option value="irish">Irish</option>
              <option value="israeli">Israeli</option>
              <option value="italian">Italian</option>
              <option value="ivorian">Ivorian</option>
              <option value="jamaican">Jamaican</option>
              <option value="japanese">Japanese</option>
              <option value="jordanian">Jordanian</option>
              <option value="kazakhstani">Kazakhstani</option>
              <option value="kenyan">Kenyan</option>
              <option value="kittian and nevisian">Kittian and Nevisian</option>
              <option value="kuwaiti">Kuwaiti</option>
              <option value="kyrgyz">Kyrgyz</option>
              <option value="laotian">Laotian</option>
              <option value="latvian">Latvian</option>
              <option value="lebanese">Lebanese</option>
              <option value="liberian">Liberian</option>
              <option value="libyan">Libyan</option>
              <option value="liechtensteiner">Liechtensteiner</option>
              <option value="lithuanian">Lithuanian</option>
              <option value="luxembourger">Luxembourger</option>
              <option value="macedonian">Macedonian</option>
              <option value="malagasy">Malagasy</option>
              <option value="malawian">Malawian</option>
              <option value="malaysian">Malaysian</option>
              <option value="maldivan">Maldivan</option>
              <option value="malian">Malian</option>
              <option value="maltese">Maltese</option>
              <option value="marshallese">Marshallese</option>
              <option value="mauritanian">Mauritanian</option>
              <option value="mauritian">Mauritian</option>
              <option value="mexican">Mexican</option>
              <option value="micronesian">Micronesian</option>
              <option value="moldovan">Moldovan</option>
              <option value="monacan">Monacan</option>
              <option value="mongolian">Mongolian</option>
              <option value="moroccan">Moroccan</option>
              <option value="mosotho">Mosotho</option>
              <option value="motswana">Motswana</option>
              <option value="mozambican">Mozambican</option>
              <option value="namibian">Namibian</option>
              <option value="nauruan">Nauruan</option>
              <option value="nepalese">Nepalese</option>
              <option value="new zealander">New Zealander</option>
              <option value="ni-vanuatu">Ni-Vanuatu</option>
              <option value="nicaraguan">Nicaraguan</option>
              <option value="nigerien">Nigerien</option>
              <option value="north korean">North Korean</option>
              <option value="northern irish">Northern Irish</option>
              <option value="norwegian">Norwegian</option>
              <option value="omani">Omani</option>
              <option value="pakistani">Pakistani</option>
              <option value="palauan">Palauan</option>
              <option value="panamanian">Panamanian</option>
              <option value="papua new guinean">Papua New Guinean</option>
              <option value="paraguayan">Paraguayan</option>
              <option value="peruvian">Peruvian</option>
              <option value="polish">Polish</option>
              <option value="portuguese">Portuguese</option>
              <option value="qatari">Qatari</option>
              <option value="romanian">Romanian</option>
              <option value="russian">Russian</option>
              <option value="rwandan">Rwandan</option>
              <option value="saint lucian">Saint Lucian</option>
              <option value="salvadoran">Salvadoran</option>
              <option value="samoan">Samoan</option>
              <option value="san marinese">San Marinese</option>
              <option value="sao tomean">Sao Tomean</option>
              <option value="saudi">Saudi</option>
              <option value="scottish">Scottish</option>
              <option value="senegalese">Senegalese</option>
              <option value="serbian">Serbian</option>
              <option value="seychellois">Seychellois</option>
              <option value="sierra leonean">Sierra Leonean</option>
              <option value="singaporean">Singaporean</option>
              <option value="slovakian">Slovakian</option>
              <option value="slovenian">Slovenian</option>
              <option value="solomon islander">Solomon Islander</option>
              <option value="somali">Somali</option>
              <option value="south african">South African</option>
              <option value="south korean">South Korean</option>
              <option value="spanish">Spanish</option>
              <option value="sri lankan">Sri Lankan</option>
              <option value="sudanese">Sudanese</option>
              <option value="surinamer">Surinamer</option>
              <option value="swazi">Swazi</option>
              <option value="swedish">Swedish</option>
              <option value="swiss">Swiss</option>
              <option value="syrian">Syrian</option>
              <option value="taiwanese">Taiwanese</option>
              <option value="tajik">Tajik</option>
              <option value="tanzanian">Tanzanian</option>
              <option value="thai">Thai</option>
              <option value="togolese">Togolese</option>
              <option value="tongan">Tongan</option>
              <option value="trinidadian or tobagonian">
                Trinidadian or Tobagonian
              </option>
              <option value="tunisian">Tunisian</option>
              <option value="turkish">Turkish</option>
              <option value="tuvaluan">Tuvaluan</option>
              <option value="ugandan">Ugandan</option>
              <option value="ukrainian">Ukrainian</option>
              <option value="uruguayan">Uruguayan</option>
              <option value="uzbekistani">Uzbekistani</option>
              <option value="venezuelan">Venezuelan</option>
              <option value="vietnamese">Vietnamese</option>
              <option value="welsh">Welsh</option>
              <option value="yemenite">Yemenite</option>
              <option value="zambian">Zambian</option>
              <option value="zimbabwean">Zimbabwean</option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("overview.table.citizen.address")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              :placeholder="$t('overview.table.citizen.address')"
              v-model="citizen.address"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <!-- edit images -->
    <b-modal
      v-if="target.image_project"
      size="lg"
      ref="ref-modal-edit"
      :id="'modal-show-images' + id"
      centered
      title=""
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <img
              :src="urlimage + target.image_project"
              class="img-fluid rounded mr-4"
              width="100%"
            />
          </div>
          <div class="title text-center">
            <h4>{{ target.title }}</h4>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add dan search target private data -->
    <b-modal
      v-if="!target.private_data"
      ref="ref-modal-add"
      :id="'modal-add-private'"
      centered
      :title="
        $t('button.add.text') + ' ' + $t('overview.table.all.private-data')
      "
      title-class="font-18"
      :ok-title="$t('button.save.text')"
      :cancel-title="$t('button.cancel.text')"
      @ok="addPrivateData($event)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">Email</label>
            <input
              id="validationCustom01"
              type="email"
              class="form-control"
              placeholder="email"
              v-model="private_data_add.email"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="validationCustom01">{{
              $t("phone.phone-number")
            }}</label>
            <input
              id="validationCustom01"
              type="text"
              class="form-control"
              v-on:input="acceptNumber(private_data_add.phone)"
              placeholder="628"
              v-model="private_data_add.phone"
            />
            <b-button
              @click="searchPhone"
              class="btn btn-sm mt-1"
              variant="primary"
              >Search</b-button
            >
          </div>
        </div>
        <div class="col-md-12">
          <div v-for="result in search_phone" :key="result.index">
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.international-format")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light"
                    :value="result.international_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.country-code")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.local_format"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.phone-number")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.country_code"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.location")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.location"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.carrier")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.carrier"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{ $t("phone.area") }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.area"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.timezone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.timezone"
                    readonly
                  />
                </p>
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.possibility")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result.possibility"
                    readonly
                  />
                </p>
              </div>
            </div>
            <hr v-if="result_telegram.tag" />
            <div class="row" v-if="result_telegram.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_telegram.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_telegram.tag"
                    readonly
                  />
                </p>
              </div>
            </div>

            <hr v-if="result_tokped.tag" />
            <div class="row" v-if="result_tokped.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_tokped.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_tokped.tag"
                    readonly
                  />
                </p>
              </div>
            </div>

            <hr v-if="result_fb.tag" />
            <div class="row" v-if="result_fb.tag">
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">{{
                    $t("phone.source")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_fb.source"
                    readonly
                  />
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <label for="validationCustom01">Tag</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="result_fb.tag"
                    readonly
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add twitter -->
    <b-modal
      size="lg"
      ref="modal-add-twitter"
      :id="'modal-add-twitter' + id"
      centered
      title="Add Twitter"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="list_twitter"
                  :fields="fields"
                  striped
                  bordered
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                  <template #cell(account)="row">
                    <div class="col-sm-12">
                      <div class="media">
                        <img
                          :src="row.item.avatar"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <b> {{ row.item.name }}</b> <br />
                          <p class="text-secondary">
                            Updated : {{ formatDate(row.item.updated_at) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button
                      class="mr-2 btn-sm"
                      @click="addTwitterTarget(row.item.id_twitter)"
                      variant="primary"
                    >
                      <i class="bx bx-plus"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsTwitter"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      ref="modal-add-twitter-search"
      :id="'modal-add-twitter-search' + id"
      centered
      title="Add Twitter"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card px-4">
            <div class="row mt-5">
              <div class="col-sm-8">
                <h5 v-if="search && !loadingsearchtwitter">
                  {{ $t("twitter.twitter-search.total-results") }} :
                  {{ totalResult }}
                </h5>
                <Particle />
              </div>
              <div class="col-sm-4 text-right">
                <div class="input-group">
                  <input
                    id="search"
                    type="text"
                    class="form-control"
                    v-model="searchKey"
                    placeholder="Search .."
                    aria-describedby="search"
                  />
                  <div class="input-group-prepend">
                    <button
                      id="search"
                      class="input-group-text bg-primary text-white"
                      @click="searchTwitter"
                    >
                      <i class="bx bx-search-alt search-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div
                class="col-sm-12"
                v-if="!search && !searchResult[0] && !loadingsearchtwitter"
              >
                <div class="p-5 m-5 justify-content-center text-secondary">
                  <h4 class="text-center py-5 my-5">...</h4>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="search && totalResult === 0 && !loadingsearchtwitter"
              >
                <div class="p-5 m-5 justify-content-center">
                  <h6 class="text-center py-5 my-5 text-secondary">
                    {{ $t("all.dnf") }}
                  </h6>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="searchResult == 0 && loadingsearchtwitter"
              >
                <div class="p-5 m-5 text-center">
                  <b-spinner label="Loading..."></b-spinner><br />
                  Loading..
                </div>
              </div>
              <div class="col-sm-12" v-if="!search || searchResult != 0">
                <div class="row">
                  <div
                    class="col-sm-4 col-md-4 mb-3"
                    v-for="(result, index) in searchResult[0]"
                    :key="index"
                  >
                    <div class="card p-3 border h-100">
                      <div class="row text-Secondary">
                        <div class="col-sm-8">
                          <div class="media mb-3">
                            <div class="avatar-md mr-2">
                              <img
                                :src="result.avatar"
                                class="mr-3 rounded-circle avatar-md"
                                alt="user-pic"
                              />
                            </div>
                            <div class="media-body">
                              <h6 class="mt-3">{{ result.name }}</h6>
                              <p class="text-secondary">
                                <span class="mb-1"
                                  >@{{ result.screen_name }}
                                  <span v-if="result.verified == true"
                                    ><i
                                      class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                                    ></i></span
                                ></span>
                                <span
                                  v-if="result.private == 1"
                                  class="text-secondary"
                                >
                                  <i
                                    class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                                  ></i>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 text-right">
                          <router-link to="#">
                            <b-button
                              class="btn btn-sm"
                              variant="primary"
                              @click="addNewTwitter(result)"
                            >
                              <!-- <div v-show="loading" class="spinner-border spinner-border-sm" role="status">
                                                    </div>  -->
                              {{ $t("twitter.twitter-search.add") }}
                            </b-button>
                          </router-link>
                        </div>
                        <div class="col-sm-6 mb-2">
                          <h6>
                            {{ $t("twitter.twitter-search.created-on") }}:
                          </h6>
                        </div>
                        <div class="col-sm-6 mb-2 text-right">
                          <span class="text-secondary">{{
                            formatDate(result.created_at)
                          }}</span>
                        </div>
                        <div class="col-sm-6 mb-2">
                          <h6>{{ $t("twitter.twitter-search.location") }}:</h6>
                        </div>
                        <div class="col-sm-6 mb-2 text-right">
                          <span class="text-secondary">{{
                            result.location
                          }}</span>
                        </div>
                        <div class="col-sm-6 mb-2">
                          <h6>{{ $t("twitter.twitter-search.tweets") }}:</h6>
                        </div>
                        <div class="col-sm-6 mb-2 text-right">
                          <span class="text-secondary">{{
                            result.tweets
                          }}</span>
                        </div>
                        <div class="col-sm-6 mb-2">
                          <h6>{{ $t("twitter.twitter-search.followers") }}:</h6>
                        </div>
                        <div class="col-sm-6 mb-2 text-right">
                          <span class="text-secondary">{{
                            result.followers
                          }}</span>
                        </div>
                        <div class="col-sm-6 mb-2">
                          <h6>{{ $t("twitter.twitter-search.following") }}:</h6>
                        </div>
                        <div class="col-sm-6 text-right">
                          <span class="text-secondary">{{
                            result.following
                          }}</span>
                        </div>
                        <div class="col-sm-12 text-center">
                          <hr />
                          <a
                            :href="'https://twitter.com/' + result.screen_name"
                            target="_blank"
                            rel="noopener noreferrer"
                            ><b>{{
                              $t("twitter.twitter-search.see-profile")
                            }}</b></a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add instagram  -->
    <b-modal
      size="lg"
      ref="modal-add-instagram"
      :id="'modal-add-instagram' + id"
      centered
      title="Add Instagram"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <div class="table-responsive mb-0">
                  <b-table
                    :items="list_instagram"
                    :fields="fieldsInstagram"
                    striped
                    bordered
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                  >
                    <template #cell(account)="row">
                      <div class="col-sm-12">
                        <div class="media">
                          <div class="col-sm-6" v-if="row.item.picture">
                            <img
                              :src="row.item.picture"
                              class="mr-3 rounded-circle avatar-sm"
                              alt="user-pic"
                            />
                          </div>
                          <div class="col-sm-6" v-else>
                            <img
                              src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                              class="rounded-circle avatar-sm"
                              alt
                            />
                          </div>
                          <div class="media-body">
                            <b> {{ row.item.full_name }}</b> <br />
                            <span class="text-secondary">
                              @{{ row.item.account }}</span
                            >
                            <br />
                            <p class="text-secondary">
                              Updated : {{ formatDate(row.item.updated_at) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #cell(actions)="row">
                      <b-button
                        class="mr-2 btn-sm"
                        @click="addInstagramTarget(row.item.id_instagram)"
                        variant="primary"
                      >
                        <i class="bx bx-plus"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsInstagram"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      ref="modal-add-instagram-search"
      :id="'modal-add-instagram-search' + id"
      centered
      title="Add Instagram"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div class="card px-4">
            <div class="row mt-5">
              <div class="col-sm-8">
                <h5 v-if="searchInstagram && !loadingsearchinstagram">
                  {{ $t("twitter.twitter-search.total-results") }} :
                  {{ totalResult }}
                </h5>
                <Particle />
              </div>
              <div class="col-sm-4 text-right">
                <div class="input-group">
                  <input
                    id="search"
                    type="text"
                    class="form-control"
                    v-model="searchKeyInstagram"
                    placeholder="Search .."
                    aria-describedby="search"
                  />
                  <div class="input-group-prepend">
                    <button
                      id="search"
                      class="input-group-text bg-primary text-white"
                      @click="searchInstagramAccount"
                    >
                      <i class="bx bx-search-alt search-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div
                class="col-sm-12"
                v-if="
                  !searchInstagram &&
                  !searchResultInstagram[0] &&
                  !loadingsearchinstagram
                "
              >
                <div class="p-5 m-5 justify-content-center text-secondary">
                  <h4 class="text-center py-5 my-5">...</h4>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="
                  searchInstagram &&
                  totalResult === 0 &&
                  !loadingsearchinstagram
                "
              >
                <div class="p-5 m-5 justify-content-center">
                  <h6 class="text-center py-5 my-5 text-secondary">
                    {{ $t("all.dnf") }}
                  </h6>
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="searchResultInstagram == 0 && loadingsearchinstagram"
              >
                <div class="p-5 m-5 text-center">
                  <b-spinner label="Loading..."></b-spinner><br />
                  Loading..
                </div>
              </div>
              <div
                class="col-sm-12"
                v-if="!searchInstagram || searchResultInstagram != 0"
              >
                <div class="row">
                  <div
                    class="col-sm-4 col-md-4 mb-3"
                    v-for="(result, index) in searchResultInstagram"
                    :key="index"
                  >
                    <div class="card p-3 border h-100">
                      <div class="row text-Secondary">
                        <div class="col-sm-8">
                          <div class="media mb-3">
                            <div class="avatar-md mr-2">
                              <img
                                src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                                class="mr-3 rounded-circle avatar-md"
                                alt="user-pic"
                              />
                            </div>
                            <div class="media-body"></div>
                          </div>
                        </div>
                        <div class="col-sm-4 text-right">
                          <router-link to="#">
                            <b-button
                              class="btn btn-sm"
                              variant="primary"
                              @click="addNewInstagram(result.screen_name)"
                            >
                              <!-- <div v-show="loading" class="spinner-border spinner-border-sm" role="status">
                                </div>  -->
                              {{ $t("instagram.add") }}
                            </b-button>
                          </router-link>
                        </div>

                        <div class="col-sm-12 mb-2">
                          <h5 class="mt-3">
                            {{ result.full_name
                            }}<i
                              class="bx bx-check-circle p-2 text-primary"
                              v-if="result.verified"
                            ></i>
                            <span
                              v-if="result.private == 1"
                              class="text-secondary"
                            >
                              <i
                                class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                              ></i>
                            </span>
                          </h5>
                          <p class="text-secondary">
                            (<span class="mb-1">@{{ result.screen_name }} </span
                            >)
                          </p>
                        </div>
                        <!-- <div class="col-sm-6 mb-2">
                                            <h6>{{ $t('instagram.post') }}:</h6>
                                        </div> -->
                        <!-- <div class="col-sm-6 mb-2 text-right">
                                            <span class="text-secondary">{{result.posting}}</span>
                                        </div>
                                        <div class="col-sm-6 mb-2">
                                            <h6>{{ $t('instagram.followers') }}:</h6>
                                        </div>
                                        <div class="col-sm-6 mb-2 text-right">
                                            <span class="text-secondary">{{result.followers}}</span>
                                        </div>
                                        <div class="col-sm-6 mb-2">
                                            <h6>{{ $t('instagram.following') }}:</h6>
                                        </div>
                                        <div class="col-sm-6 text-right">
                                            <span class="text-secondary">{{result.following}}</span>
                                        </div> -->
                        <div class="col-sm-12 text-center">
                          <hr />
                          <a
                            :href="
                              'https://www.instagram.com/' + result.screen_name
                            "
                            target="_blank"
                            rel="noopener noreferrer"
                            ><b>{{ $t("instagram.see-profile") }}</b></a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import { barChart } from "./data-overview";
import CategoryService from "@/helpers/category.service";
import { required } from "vuelidate/lib/validators";
import PhoneService from "@/helpers/phone.service.js";
import AdvancedService from "@/helpers/advanced.service";
import TwintService from "@/helpers/twint.service.js";
import InstaService from "@/helpers/osintgram.service.js";
// import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import MediaHunt from "./media-hunt.vue";
// import Timeline from "./timeline.vue";
import Advanced from "./advanced.vue";
import News from "./news.vue";
import RelationImage from "./relation-image.vue";
import Cytoscape from "./ontologi.vue";
import Sna from "./social-network-analys.vue";
import Website from "./website.vue";
import NewsAnalytic from "./news-analytic.vue";
import AddWebsite from "./add-website.vue";
import Progress from "./progress.vue";
import Swal from "sweetalert2";
import moment from "moment";
import VueSlideBar from "vue-slide-bar";
import UserService from "@/helpers/user.service";
import CitizenService from "@/helpers/citizen.service";
import simplebar from "simplebar-vue";
import BreachService from "@/helpers/breach.service";
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  page: {
    title: "Project Overview",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    ckeditor: CKEditor.component,
    Layout,
    PageHeader,
    VueSlideBar,
    // Timeline,
    RelationImage,
    MediaHunt,
    Advanced,
    News,
    Cytoscape,
    // Website,
    AddWebsite,
    simplebar,
    NewsAnalytic,
    Sna,
    Progress,
  },
  data() {
    const gaugeOptions = {
      chart: {
        height: 200,
        type: "radialBar",
        offsetY: 0,
      },
      plotOptions: {
        radialBar: {
          track: {
            background: "transparent",
          },
          hollow: {
            margin: 5,
            size: "50%",
            background:
              localStorage.getItem("theme") == "dark" ? "#000000" : "#ffffff",
            image: undefined,
            imageWidth: 150,
            imageHeight: 150,
            imageOffsetX: 0,
            imageOffsetY: 0,
            imageClipped: true,
            position: "front",
            dropShadow: {
              enabled: false,
              top: 0,
              left: 0,
              blur: 3,
              opacity: 0.5,
            },
          },
          startAngle: -135,
          endAngle: 135,
          dataLabels: {
            name: {
              fontSize: "12px",
              color:
                localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000",
              offsetY: 60,
            },
            value: {
              offsetY: 0,
              fontSize: "16px",
              color:
                localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000",
              formatter: function (val) {
                return val;
              },
            },
          },
        },
      },
      fill: {
        opacity: 1.5,
        type: "gradient",
        colors: [
          localStorage.getItem("theme") == "dark" ? "#FFFFFF" : "#000000",
        ],
        gradient: {
          shade: "dark",
          shadeIntensity: 0.15,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 65, 91],
        },
      },
      stroke: {
        dashArray: 4,
      },
      labels: [this.$t("overview.table.all.score")],
    };
    return {
      editor: ClassicEditor,
      editorData: "<h5></h5>",
      text_editor: "",
      family: [],
      backUrl: "/project",
      id_user: "",
      pref: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search_instagram: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_search_instagram_avatar: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      pref_userinfo: {
        api_host: "",
        x_rapidapi_host: "",
        x_rapidapi_key: "",
      },
      avatar_instagram:
        "https://img.icons8.com/ios/240/000000/user-male-circle.png",
      error: "",
      result_telegram: "",
      loadingsearchtwitter: false,
      loadingsearchinstagram: false,
      loadingsearchwebsite: false,
      result_tokped: "",
      result_fb: "",
      exposed: [],
      elastic: "",
      loadingtele: "",
      user_type: "",
      data_breach: "",
      username_analys: "",
      username_manager: "",
      telegram_add: {
        account: "",
        user_id: "",
        first_name: "",
        last_name: "",
        access_hash: "",
        phone: "",
        group_list: "",
      },
      group_result: "",
      group_result_not_found: "",
      show: false,
      searching: "",
      options: [],
      gaugeSeries: [],
      gaugeOptions: gaugeOptions,
      id: this.$route.params.id,
      loading: false,
      urlimage: process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      avatarig: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-profil/?name=",
      barChart: barChart,
      search: false,
      searchInstagram: false,
      // searchWebsite: false,
      // SearchResultWebsite: "",
      // SearchResultWebsite:[],
      searchResult: [],
      searchResultInstagram: [],
      totalResult: "",
      searchKey: "",
      // searchKeyWebsite: "",
      searchKeyInstagram: "",
      list_twitter: [],
      list_instagram: [],
      // list_website: [],
      id_template: "",
      template: [],
      target: [],
      twitter: [],
      telegram: [],
      // facebook: [],
      // tiktok: [],
      // youtube: [],
      citizen: [],
      instagram: [],
      private_web: "",
      private_data: [],
      advanced_ecomm: [],
      advanced_socmed: [],
      other: [],
      tags: [],
      private_data_add: {
        email: "",
        phone: "",
      },
      image_project: "",
      form: {
        title: "",
        description: "",
        address: "",
        category_score: 0,
      },
      relation: [],
      search_phone_key: "",
      search_phone: [
        {
          international_format: "",
          local_format: "",
          country_code: "",
          location: "",
          carrier: "",
          area: "",
          timezone: "",
          possibility: "",
        },
      ],
      submitted: false,
      id_category: "",
      category: [],
      categoryAll: [],
      title: this.$t("overview.project-overview.text"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("overview.project.text"),
          href: "/project",
        },
        {
          text: this.$t("overview.project-overview.text"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        { key: "id_twitter", thClass: "d-none", tdClass: "d-none" },
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },
        { key: "updated_at", thClass: "d-none", tdClass: "d-none" },
        { key: "screen_name", thClass: "d-none", tdClass: "d-none" },
        {
          key: "account",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.following"),
        },
        { key: "join_at", thClass: "d-none", tdClass: "d-none" },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
        },
      ],
      fieldsInstagram: [
        { key: "id_instagram", thClass: "d-none", tdClass: "d-none" },
        { key: "user_id", thClass: "d-none", tdClass: "d-none" },
        { key: "picture", thClass: "d-none", tdClass: "d-none" },
        { key: "updated_at", thClass: "d-none", tdClass: "d-none" },
        { key: "full_name", thClass: "d-none", tdClass: "d-none" },
        {
          key: "account",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.following"),
        },
        { key: "join_at", thClass: "d-none", tdClass: "d-none" },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
        },
      ],
      // fieldsWebsite: [
      //   { key: "id_web_info", thClass: "d-none", tdClass: "d-none" },
      //   { key: "domain_name", sortable: true, label: "Domain Name" },
      //   {
      //     key: "ip_address",
      //     sortable: true,
      //     class: "text-center",
      //     label: "IP Address",
      //   },
      //   {
      //     key: "ip_location",
      //     sortable: true,
      //     class: "text-center",
      //     label: "IP Location",
      //   },
      //   {
      //     key: "actions",
      //     class: "text-center",
      //     label: this.$t("twitter.table.action"),
      //   },
      // ],
    };
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      relation: {},
    },
  },
  computed: {
    rowsInstagram() {
      return this.list_instagram.length;
    },
    // rowsWebsite() {
    //   return this.list_website.length;
    // },
    rowsTwitter() {
      return this.list_twitter.length;
    },
    criteria() {
      return this.searching.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.relation.length; i++) {
          element.push(JSON.parse(this.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1 && opt.id != this.id
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
  },
  watch: {
    citizen: {
      handler(n, o) {
        if (n?.length != 0) {
          this.getRelatedFamily();
        }
      },
      deep: true,
    },
  },
  methods: {
    countAge(date) {
      var date = this.formatDateSave(date);
      var mount = Math.floor(
        moment(new Date()).diff(moment(date, "YYYY-MM-DD"), "month", true)
      );
      var years = Math.floor(
        moment(new Date()).diff(moment(date, "YYYY-MM-DD"), "years", true)
      );
      var days = Math.floor(
        moment(new Date()).diff(moment(date, "YYYY-MM-DD"), "days", true)
      );

      var mm = mount;
      var yr = years;
      var dd = days;

      this.month = mm;
      this.years = yr;
      this.days = dd;

      var m = mm - yr * 12;
      var dx = dd - yr * 365;
      var ds = dx / 12;
      var d = this.toFixed(ds);

      var day = parseInt(d);
      var month = m;
      var years = years;

      return years;
      // this.age = years +' Tahun, '+ month +' Bulan, '+ day +' Hari';
    },

    getPreferencesSearch() {
      let id = 10;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_search_instagram.api_host = response.data.data.api_host;
          this.pref_search_instagram.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_search_instagram.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesUserInfo() {
      let id = 13;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref_userinfo = response.data.data;
          this.pref_userinfo.api_host = response.data.data.api_host;
          this.pref_userinfo.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_userinfo.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferencesAvatarInstagram() {
      let id = 62;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log(response.data.data);
          // this.pref = response.data.data;
          this.pref_search_instagram_avatar.api_host =
            response.data.data.api_host;
          this.pref_search_instagram_avatar.x_rapidapi_host =
            response.data.data.api_header_host;
          this.pref_search_instagram_avatar.x_rapidapi_key =
            response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getRelatedFamily() {
      // console.log("Related FAM ", this.citizen);
      if (this.citizen && this.citizen.nkk != 0 && this.citizen.nkk != "") {
        let data = {
          size: 100,
          query: {
            match: {
              nkk: this.citizen?.nkk,
            },
          },
        };
        if (this.citizen) {
          CitizenService.search(this.elastic, data)
            .then((response) => {
              this.family = response.data.hits.hits;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },

    listUser() {
      UserService.getProfile()
        .then((response) => {
          this.id_user = response.data.data.id_user;
          this.user_type = response.data.data.user_type;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    getBreach() {
      let id = this.id;
      AdvancedService.getBreach(id)
        .then((response) => {
          this.data_breach = response.data.data;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    getAnalys() {
      var data_id = this.target.id_analys;
      UserService.getEditUser(data_id)
        .then((response) => {
          this.username_analys = response.data.data.username;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    getManager() {
      var data_id = this.target.manager;
      UserService.getEditUser(data_id)
        .then((response) => {
          this.username_manager = response.data.data.username;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },

    listProfile() {
      TargetService.getAllTarget()
        .then((response) => {
          response.data.data.forEach((val) => {
            const opt = {
              name: val.title,
              id: val.id_target,
              image: val.image_project,
            };
            this.options.push(opt);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onOptionClick({ option, addTag }) {
      try {
        this.relation.push({
          name: option.name,
          id: option.id,
          image: option.image,
        });
      } catch (error) {
        console.log("err =>", error);
      }
      this.show = false;
      this.searching = "";
    },

    parseUrl(url) {
      let loc = new URL(url);
      let url_icon = "";
      switch (loc.host) {
        case "www.capfriendly.com":
          url_icon =
            loc.protocol +
            "//" +
            loc.host +
            "/assets/images/favicons/favicon.ico";
          break;

        default:
          url_icon = loc.protocol + "//" + loc.host + "/favicon.ico";
          break;
      }
      return url_icon;
    },

    comingSoon() {
      alert("Coming Soon!");
    },
    //  list get data
    listTwitter() {
      SocmedService.getAllTwitter()
        .then((response) => {
          this.list_twitter = response.data.data;
        })
        .catch((err) => {
          console.log("listTwit -> ", err);
        });
    },

    listInstagram() {
      SocmedService.getAllInstagram()
        .then((response) => {
          this.list_instagram = response.data.data;
        })
        .catch((err) => {
          console.log("list Inst -> ", err);
        });
    },

    getTargetDetail() {
      console.log("TARGET DETAIL");
      this.relation = [];
      TargetService.getDetailTarget(this.id)
        .then((response) => {
          console.log("target detail == ==>", response);
          this.target = response.data.data;
          this.gaugeSeries = [
            response.data.data.category_score == null ||
            response.data.data.category_score == ""
              ? 0
              : response.data.data.category_score,
          ];
          this.form = response.data.data;
          this.form.category_score =
            response.data.data.category_score == null ||
            response.data.data.category_score == ""
              ? 0
              : response.data.data.category_score;
          this.relation = JSON.parse(
            "[" + response.data.data.relation_profile + "]"
          );
          // this.id_template = response.data.data.id_template;
          this.template = response.data.data.template;
          this.citizen = response.data.data.citizen;
          this.twitter = response.data.data.twitter;
          this.telegram = response.data.data.telegram;
          // this.tiktok = response.data.data.tiktok;
          // this.youtube = response.data.data.youtube;
          // this.facebook = response.data.data.facebook;
          this.instagram = response.data.data.instagram;
          this.private_web = response.data.data.private_web[0];
          this.private_data = response.data.data.private_data;
          this.other = response.data.data.other;
          this.advanced_socmed = response.data.data.advanced_fb;
          this.advanced_ecomm = response.data.data.advanced_tokped;
          this.private_data_add.email = response.data.data.private_data
            ? response.data.data.private_data.email
            : "";
          this.private_data_add.phone = response.data.data.private_data
            ? response.data.data.private_data.phone
            : "";
          // console.log('2=>',this.form.relation);
          this.getAnalys();
          this.getManager();
          this.getTags();
        })
        .catch((err) => {
          console.log("d target -> ", err);
        });
    },

    getCategory() {
      CategoryService.list()
        .then((response) => {
          this.categoryAll = response.data.data;
        })
        .catch((err) => {
          console.log("category -> ", err);
        });
    },

    getTags() {
      if (this.private_data && this.private_data.id_contact) {
        PhoneService.detail_contact(this.private_data.id_contact)
          .then((response) => {
            this.tags = response.data.data.tags;
          })
          .catch((err) => {
            console.log("tags -> ", err);
          });
      }
    },
    // add data
    addTwitterTarget(id_twit) {
      var data = {
        title: this.form.title,
        description: this.form.description,
        category: this.form.category,
        status: this.form.status,
        manager: this.form.manager,
        relation_profile: this.form.relation_profile,
        id_citizen: this.form.id_citizen,
        id_private_data: this.form.id_private_data,
        id_telegram: this.form.id_telegram,
        id_twitter: id_twit,
        id_facebook: this.form.id_facebook,
        id_instagram: this.form.id_instagram,
        id_private_web: this.form.id_private_web,
        other_description: this.form.other_description,
      };

      TargetService.updateTargetProfile(this.id, data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "twitter added successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          this.getTargetDetail();
          this.addTwitterHide();
          this.listTwitter();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addInstagramTarget(id_insta) {
      var data = {
        title: this.form.title,
        description: this.form.description,
        category: this.form.category,
        status: this.form.status,
        manager: this.form.manager,
        relation_profile: this.form.relation_profile,
        id_citizen: this.form.id_citizen,
        id_private_data: this.form.id_private_data,
        id_telegram: this.form.id_telegram,
        id_twitter: this.form.id_twitter,
        id_facebook: this.form.id_facebook,
        id_instagram: id_insta,
        id_private_web: this.form.id_private_web,
        other_description: this.form.other_description,
      };
      TargetService.updateTargetProfile(this.id, data)
        .then((response) => {
          Swal.fire(this.$t("alert.alert-save"), "", "success");
          this.getTargetDetail();
          this.addInstagramHide();
          this.listInstagram();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addInstagramTarget(id_insta) {
      var data = {
        title: this.form.title,
        description: this.form.description,
        category: this.form.category,
        status: this.form.status,
        manager: this.form.manager,
        relation_profile: this.form.relation_profile,
        id_citizen: this.form.id_citizen,
        id_private_data: this.form.id_private_data,
        id_telegram: this.form.id_telegram,
        id_twitter: this.form.id_twitter,
        id_facebook: this.form.id_facebook,
        id_instagram: id_insta,
        id_private_web: this.form.id_private_web,
        other_description: this.form.other_description,
      };
      TargetService.updateTargetProfile(this.id, data)
        .then((response) => {
          Swal.fire(this.$t("alert.alert-save"), "", "success");
          this.getTargetDetail();
          this.addInstagramHide();
          this.listInstagram();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // delete data
    deleteTargetCitizen(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          CitizenService.delete(id)
            .then((response) => {
              this.getTargetDetail();
              (this.citizen = ""),
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Data Deleted Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteTargetTwitter(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = {
            title: this.form.title,
            description: this.form.description,
            category: this.form.category,
            status: this.form.status,
            manager: this.form.manager,
            relation_profile: this.form.relation_profile,
            id_citizen: this.form.id_citizen,
            id_private_data: this.form.id_private_data,
            id_telegram: this.form.id_telegram,
            id_twitter: "NULL",
            id_facebook: this.form.id_facebook,
            id_instagram: this.form.id_instagram,
            id_private_web: this.form.id_private_web,
            other_description: this.form.other_description,
          };
          TargetService.updateTargetProfile(id, data)
            .then((response) => {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "twitter deleted successfully",
                showConfirmButton: false,
                timer: 2500,
              });
              this.getTargetDetail();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteTargetInstagram(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = {
            title: this.form.title,
            description: this.form.description,
            category: this.form.category,
            status: this.form.status,
            manager: this.form.manager,
            relation_profile: this.form.relation_profile,
            id_citizen: this.form.id_citizen,
            id_private_data: this.form.id_private_data,
            id_telegram: this.form.id_telegram,
            id_twitter: this.form.id_twitter,
            id_facebook: this.form.id_facebook,
            id_instagram: "NULL",
            id_private_web: this.form.id_private_web,
            other_description: this.form.other_description,
          };
          TargetService.updateTargetProfile(id, data)
            .then((response) => {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Instagram deleted successfully",
                showConfirmButton: false,
                timer: 2500,
              });
              this.getTargetDetail();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    deleteTelegramData(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          SocmedService.deleteTelegram(id)
            .then((response) => {
              this.getTargetDetail();
              (this.telegram = ""),
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Data Deleted Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    ImageTarget(evt) {
      this.image_project = evt.target.files[0];
    },

    // tampil modal
    addTwitter(id) {
      this.$bvModal.show("modal-add-twitter" + id);
    },
    addTwitterSearch(id) {
      this.$bvModal.show("modal-add-twitter-search" + id);
    },
    addTwitterHide(id) {
      this.$refs["modal-add-twitter"].hide();
    },
    addTwitterSearchHide(id) {
      this.$refs["modal-add-twitter-search"].hide();
    },
    addInstagramSearch(id) {
      this.$bvModal.show("modal-add-instagram-search" + id);
    },
    addInstagramHide(id) {
      this.$refs["modal-add-instagram"].hide();
    },
    addInstagramSearchHide(id) {
      this.$refs["modal-add-instagram-search"].hide();
    },

    addInstagram(id) {
      this.$bvModal.show("modal-add-instagram" + id);
    },

    editTarget(id) {
      this.$bvModal.show("modal-edit" + id);
      // this.refreshSlider();
    },
    editTargetImages(id) {
      this.$bvModal.show("modal-edit-images" + id);
    },
    showTargetImages(id) {
      this.$bvModal.show("modal-show-images" + id);
    },
    editTargetPrivate(id) {
      this.$bvModal.show("modal-edit-private" + id);
    },
    editTargetTwitter(id) {
      this.$bvModal.show("modal-edit-twitter" + id);
    },
    editTargetFacebook(id) {
      this.$bvModal.show("modal-edit-facebook" + id);
    },
    editTargetInstagram(id) {
      this.$bvModal.show("modal-edit-instagram" + id);
    },
    editTargetYoutube(id) {
      this.$bvModal.show("modal-edit-youtube" + id);
    },
    editTargetTiktok(id) {
      this.$bvModal.show("modal-edit-tiktok" + id);
    },
    editTargetCitizen(id) {
      this.$bvModal.show("modal-edit-citizen" + id);
    },
    editTargetTelegram(id) {
      this.$bvModal.show("modal-edit-telegram" + id);
    },
    addTargetTelegram() {
      this.$bvModal.show("modal-add-telegram");
      this.group_result = [];
      this.telegram_add = {
        account: "",
        user_id: "",
        first_name: "",
        last_name: "",
        access_hash: "",
        phone: "",
        group_list: "",
      };
    },
    addTargetTelegramPhone() {
      this.$bvModal.show("modal-add-telegram-phone");
      this.group_result = [];
      this.telegram_add = {
        account: "",
        user_id: "",
        first_name: "",
        last_name: "",
        access_hash: "",
        phone: "",
        group_list: "",
      };
    },
    editTargetPrivateWeb(id) {
      this.$bvModal.show("modal-edit-private-web" + id);
    },
    addTargetPrivate() {
      this.$bvModal.show("modal-add-private");
    },
    updateTarget(e, id) {
      this.submitted = true;
      this.$v.$touch();
      if (this.form.title == "" || this.form.description == "") {
        e.preventDefault();
      } else {
        let relation = JSON.stringify(JSON.parse("[" + this.relation + "]"));
        let data = {
          title: this.form.title,
          description: this.form.description,
          id_category: this.form.id_category,
          address: this.form.address,
          category_score: this.form.category_score,
          other_description: this.form.other_description,
          relation_profile: relation.replace(/(\[|\])/g, ""),
        };

        // console.log('tesss', data);
        TargetService.updateTargetProfile(id, data)
          .then((response) => {
            this.getTargetDetail();
            this.getCategory();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$v.$reset();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    updateTargetImages(e, id) {
      const formImages = new FormData();
      formImages.append(
        "image_project",
        this.image_project,
        this.image_project.name
      );
      TargetService.updateTargetImages(id, formImages)
        .then((response) => {
          this.getTargetDetail();
          this.getCategory();
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addPrivateData(e) {
      var data = {
        email: this.private_data_add.email,
        phone: this.private_data_add.phone,
        phone_international_format: this.search_phone[0].international_format,
        phone_local_format: this.search_phone[0].local_format,
        phone_country_code: this.search_phone[0].country_code,
        phone_location: this.search_phone[0].location,
        phone_carrier: this.search_phone[0].carrier,
        phone_area: this.search_phone[0].area,
        phone_timezone: this.search_phone[0].timezone,
        phone_possibility: this.search_phone[0].possibility,
      };
      SocmedService.createPrivateDataTarget(this.id, data)
        .then((response) => {
          // console.log(response.data.data);
          this.getRapid(this.private_data_add.email);
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });

          this.getTargetDetail();
          this.private_data_add = [];

          if (this.result_telegram.tag) {
            this.AddTargetTagtele();
          }

          if (this.result_tokped.tag) {
            this.AddTargetTagTokped();
          }

          if (this.result_fb.tag) {
            this.AddTargetTagFb();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    AddTargetTagtele() {
      const data = {
        id_target: this.id,
        name: this.result_telegram.tag,
        surname: "",
        phone_number: this.result_telegram.phone,
        country_code: "",
        display_name: "",
        profile_image: "",
        email: "x",
        is_spam: "",
        remain_count: 1,
        tags: '["' + this.result_telegram.tag + '"]',
      };
      // console.log(data);
      PhoneService.add_contact(data)
        .then((response) => {
          // console.log(response.data);
          // Vue.swal({
          //     position: "top-end",
          //     icon: "success",
          //     title: "Success Add To Project",
          //     showConfirmButton: false,
          //     timer: 2000
          // });
          this.result_telegram = [];
          this.getTargetDetail();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    AddTargetTagTokped() {
      const data = {
        id_target: this.id,
        name: this.result_tokped.tag,
        surname: "",
        phone_number: this.result_tokped.phone,
        country_code: "",
        display_name: "",
        profile_image: "",
        email: "x",
        is_spam: "",
        remain_count: 1,
        tags: '["' + this.result_tokped.tag + '"]',
      };
      // console.log(data);
      PhoneService.add_contact(data)
        .then((response) => {
          // console.log(response.data);
          // Vue.swal({
          //     position: "top-end",
          //     icon: "success",
          //     title: "Success Add To Project",
          //     showConfirmButton: false,
          //     timer: 2000
          // });
          this.result_tokped = [];
          this.getTargetDetail();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    AddTargetTagFb() {
      const data = {
        id_target: this.id,
        name: this.result_fb.tag,
        surname: "",
        phone_number: this.result_fb.phone,
        country_code: "",
        display_name: "",
        profile_image: "",
        email: "x",
        is_spam: "",
        remain_count: 1,
        tags: '["' + this.result_fb.tag + '"]',
      };
      // console.log(data);
      PhoneService.add_contact(data)
        .then((response) => {
          // console.log(response.data);
          // Vue.swal({
          //     position: "top-end",
          //     icon: "success",
          //     title: "Success Add To Project",
          //     showConfirmButton: false,
          //     timer: 2000
          // });
          this.result_fb = [];
          this.getTargetDetail();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getPreferences() {
      let id = 3;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          this.pref.api_host = response.data.data.api_host;
          this.pref.x_rapidapi_host = response.data.data.api_header_host;
          this.pref.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getRapid(email) {
      // console.log(email);
      const options = {
        method: "GET",
        url: this.pref.api_host,
        params: { func: "auto", term: email },
        headers: {
          "content-type": "application/json",
          "x-rapidapi-host": this.pref.x_rapidapi_host,
          "x-rapidapi-key": this.pref.x_rapidapi_key,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.success) {
            // console.log("rapid found");
            response.data.result.forEach((el) => {
              this.exposed.push({
                email: this.private_data_add.email,
                has_password: el.has_password,
                password: el.password ?? "",
                hash: el.hash ?? "",
                source: el.sources[0].length > 1 ? el.sources[0] : el.sources,
              });
            });
            // console.log("save rapid result");
            this.addToTargetExposed();
          } else {
            // console.log("rapid not found");
          }
        })
        .catch((error) => {
          console.log(this.exposed);
        });
    },

    addToTargetExposed() {
      let data = {
        id_target: this.id,
        data: this.exposed,
      };
      // console.log(data);
      BreachService.saveBreach(data)
        .then((response) => {
          //   Vue.swal({
          //       position: "top-end",
          //       icon: "success",
          //       title: response.data.message,
          //       showConfirmButton: false,
          //       timer: 1500
          //   });
          this.getBreach();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editPrivateData(e, id) {
      if (!this.search_phone[0].international_format) {
        var data = {
          email: this.private_data_add.email,
          phone: this.private_data_add.phone,
          phone_international_format:
            this.private_data.phone_international_format,
          phone_local_format: this.private_data.phone_local_format,
          phone_country_code: this.private_data.phone_country_code,
          phone_location: this.private_data.phone_location,
          phone_carrier: this.private_data.phone_carrier,
          phone_area: this.private_data.phone_area,
          phone_timezone: this.private_data.phone_timezone,
          phone_possibility: this.private_data.phone_possibility,
        };
      } else {
        var data = {
          email: this.private_data_add.email,
          phone: this.private_data_add.phone,
          phone_international_format: this.search_phone[0].international_format,
          phone_local_format: this.search_phone[0].local_format,
          phone_country_code: this.search_phone[0].country_code,
          phone_location: this.search_phone[0].location,
          phone_carrier: this.search_phone[0].carrier,
          phone_area: this.search_phone[0].area,
          phone_timezone: this.search_phone[0].timezone,
          phone_possibility: this.search_phone[0].possibility,
        };
      }
      SocmedService.updatePrivateData(this.private_data.id_private_data, data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });

          this.getTargetDetail();

          if (this.result_telegram.tag) {
            this.AddTargetTagtele();
          }

          if (this.result_tokped.tag) {
            this.AddTargetTagTokped();
          }

          if (this.result_fb.tag) {
            this.AddTargetTagFb();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    delPrivateData(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          SocmedService.deletePrivateData(id)
            .then((response) => {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.getTargetDetail();
              this.search_phone = "";
              this.private_data_add.email = "";
              this.private_data_add.phone = "";
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    editPrivateWeb(e, id) {
      SocmedService.updatePrivateWeb(id, this.private_web)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editTwitter(e, id) {
      SocmedService.updateTwitter(id, this.twitter)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editInstagram(e, id) {
      SocmedService.updateInstagram(id, this.instagram)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    searchGroupTele(username) {
      this.loadingtele = true;
      this.group_result_not_found = "";
      var data = {
        size: 1000,
        query: {
          match: {
            "listmember.username.keyword": username,
          },
        },
      };
      GroupService.SearchGroupByUsername(this.elastic, data)
        .then((response) => {
          this.loadingtele = false;
          this.group_result = response.data.hits.hits;
          if (response.data.hits.total.value == 0) {
            this.group_result_not_found = "not found";
          }
        })
        .catch((err) => {
          console.log(err);
          this.group_result = "Data not found";
          this.loadingtele = false;
        });
    },

    SearchPhoneTele(number) {
      this.group_result_not_found = "";
      const data = {
        size: 1000,
        query: {
          match: {
            "listmember.phone.keyword": number,
          },
        },
      };
      // console.log(data);
      if (this.telegram_add.phone != "") {
        this.loadingtele = true;
        GroupService.SearchGroupByPhone(this.elastic, data)
          .then((response) => {
            let username = response.data.hits.hits[0]._id;
            // console.log(username);
            this.group_result = response.data.hits.hits;
            if (response.data.hits.total.value == 0) {
              this.group_result_not_found = "not found";
            }
            this.getUserTele(username);
            this.loadingtele = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingtele = false;
          });
      }
    },

    addTelegram(e) {
      var data = {
        id_target: this.id,
        account: this.telegram_add.account,
        user_id: this.telegram_add.user_id,
        first_name: this.telegram_add.first_name,
        last_name: this.telegram_add.last_name,
        access_hash: this.telegram_add.access_hash,
        phone: this.telegram_add.phone,
        group_list: JSON.stringify(this.group_result),
      };
      SocmedService.createTelegram(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
          this.getTargetDetail();
          this.group_result;
          this.telegram_add.account = "";
          (this.telegram_add.user_id = ""),
            (this.telegram_add.first_name = ""),
            (this.telegram_add.last_name = ""),
            (this.telegram_add.access_hash = ""),
            (this.telegram_add.phone = ""),
            (this.telegram_add.group_list = "");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editTelegram(e, id) {
      var data = {
        id_target: this.id,
        account: this.telegram.account,
        user_id: this.telegram.user_id,
        first_name: this.telegram.first_name,
        last_name: this.telegram.last_name,
        access_hash: this.telegram.access_hash,
        phone: this.telegram.phone,
        group_list: JSON.stringify(this.group_result),
      };
      SocmedService.updateTelegram(id, data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.getTargetDetail();
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editCitizen(e, id) {
      SocmedService.updateCitizen(id, this.citizen)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$v.$reset();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // search phone
    async searchPhone() {
      this.search = true;
      const data = {
        number: this.private_data_add.phone,
      };
      const data2 = {
        phone: this.private_data_add.phone,
      };
      this.search_phone = [];
      await PhoneService.search(data)
        .then((response) => {
          this.search_phone.push(response.data.output);
          this.searchTagPhone();
          this.searchTagPhoneTokped();
          this.searchTagPhoneFb();
        })
        .catch((err) => {
          console.log(err);
          this.search = false;
        });
      await PhoneService.tags(data2)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },

    searchTagPhone() {
      const data = {
        size: 1000,
        query: {
          match: {
            "listmember.phone.keyword": this.private_data_add.phone,
          },
        },
      };
      // console.log(data);
      GroupService.SearchGroupByPhone(this.elastic, data)
        .then((response) => {
          this.loadingGrup = false;
          var username = response.data.hits.hits[0]._id;
          this.getUserTele(username);
          // console.log("username", username);
        })
        .catch((err) => {
          console.log(err);
          this.search = false;
          this.loadingGrup = false;
        });
    },

    getUserTele(username) {
      const data = {
        size: 1000,
        query: {
          match: {
            username: username,
          },
        },
      };
      GroupService.SearchListMemberByGroup(this.elastic, data)
        .then((response) => {
          var dataMember = response.data.hits.hits[0]._source.listmember;
          // console.log("data member", dataMember);
          dataMember.forEach((val) => {
            const data = {
              source: "telegram",
              tag: val.username,
              phone: val.phone,
            };

            const data1 = {
              source: "telegram",
              tag: val.first_name + " " + val.last_name,
              phone: val.phone,
            };

            if (this.telegram_add.phone == val.phone) {
              // this.userList.push(data);
              (this.telegram_add.user_id = val.user_id),
                (this.telegram_add.username = val.username),
                (this.telegram_add.first_name = val.first_name),
                (this.telegram_add.last_name = val.last_name),
                (this.telegram_add.phone = val.phone);
            }

            if (data.phone == this.private_data_add.phone) {
              if (val.username) {
                this.result_telegram = data;
                // console.log('us', data);
              } else if (val.first_name || val.last_name) {
                this.result_telegram = data1;
                // console.log("fn", data);
              }
            }
          });
        })

        .catch((err) => {
          console.log(err);
          this.search = false;
          this.loading = false;
        });
    },

    searchTagPhoneTokped() {
      var data = {
        size: 1,
        query: {
          match: {
            phone: this.private_data_add.phone,
          },
        },
      };
      // console.log('tokped', data);
      PhoneService.searchPhoneTokped(this.elastic, data)
        .then((response) => {
          const res = response.data.hits;
          let tag = res.hits[0]._source.full_name;
          let phone = res.hits[0]._source.phone;
          const data = {
            source: "e-commerce",
            tag: tag,
            phone: phone,
          };
          this.result_tokped = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    searchTagPhoneFb() {
      var number = this.private_data_add.phone.substr(2, 20);
      const data = {
        size: 1,
        query: {
          match: {
            phone: number,
          },
        },
      };
      // console.log('tokped', data);
      PhoneService.searchPhoneFb(this.elastic, data)
        .then((response) => {
          const res = response.data.hits;
          let tag = res.hits[0]._source.full_name;
          let phone = res.hits[0]._source.phone;
          const data = {
            source: "socmed",
            tag:
              res.hits[0]._source.firstName +
              " " +
              res.hits[0]._source.lastName,
            phone: "62" + phone,
          };
          this.result_fb = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // search from internet
    searchTwitter() {
      this.loadingsearchtwitter = true;
      this.search = true;
      const data = {
        query: this.searchKey,
      };

      this.searchResult = [];
      if (this.searchKey != "") {
        TwintService.search(data)
          .then((response) => {
            this.searchResult.push(response.data.output);
            this.totalResult = response.data.output.length;
            this.loadingsearchtwitter = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingsearchtwitter = false;
          });
      } else {
        this.loadingsearchtwitter = false;
        this.search = false;
      }
    },
    addNewTwitter(result) {
      Swal.showLoading();
      var dataSave = {
        id_target: this.id,
        account: result.screen_name,
        user_id: result.user_id,
        name: result.name,
        avatar: result.avatar,
        followers: result.followers,
        following: result.following,
        tweets: result.tweets,
        favorites: result.favorites,
        likes: result.likes,
        media: result.media,
        location: result.location,
        bio: result.bio,
        is_private: result.private,
        is_verified: result.verified,
        join_at: result.created_at,
      };
      SocmedService.createTwitter(dataSave)
        .then((response) => {
          this.getTargetDetail();
          this.addTwitterHide();
          this.addTwitterSearchHide();
          this.listTwitter();
          this.loadingsearchtwitter = false;
          this.search = false;
          this.searchKey = "";
          this.searchResult = [];
          this.totalResult = 0;

          if (response.status == 212) {
            Swal.fire("Twitter is Updated", "", "success");
          } else {
            Swal.fire(this.$t("alert.alert-save"), "", "success");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //search from internet instagram
    searchInstagramAccount() {
      this.searchInstagram = true;
      this.loading = true;
      this.loadingsearchinstagram = true;
      const data = {
        nama: this.searchKeyInstagram,
      };
      this.searchResultInstagram = [];
      if (this.searchKeyInstagram != "") {
        InstaService.search(data)
          .then((response) => {
            this.searchResultInstagram.push(response.data.output[0]);
            this.totalResult = response.data.output.length;
            this.loadingsearchinstagram = false;
            this.loading = false;
          })
          .catch((err) => {
            this.searchIntagram();
            console.log(err);
          });
      } else {
        this.loadingsearchinstagram = false;
        this.searchInstagram = false;
      }
    },

    searchIntagram() {
      // console.log('search instagram');
      let searchData = this.removeSpace(this.searchKeyInstagram);
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_search_instagram.x_rapidapi_host,
        "x-rapidapi-key": this.pref_search_instagram.x_rapidapi_key,
      };
      // console.log(headers, this.searchKeyInstagram);
      return axios
        .get(this.pref_search_instagram.api_host + "?user=" + searchData, {
          headers: headers,
        })
        .then((response) => {
          // console.log(response.data.users);
          response.data.users.forEach((val) => {
            const new_data = {
              screen_name: val.user.username,
              full_name: val.user.full_name,
              verified: val.user.is_verified,
              private: val.user.is_private,
            };
            // console.log(new_data);
            this.searchResultInstagram.push(new_data);
          });

          this.totalResult = response.data.users.length;
          this.loading = false;
          this.loadingsearchinstagram = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.loadingsearchinstagram = false;
        });
    },

    addNewInstagram(username) {
      Swal.fire({
        title: this.$t("alert.alert-add") + username + " ?",
        showCancelButton: true,
        confirmButtonText: "Save",
        confirmButtonColor: "#0067AC",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.showLoading();
          let data = {
            nama: username,
          };

          this.getAvatarInstagram(username);
          // console.log(data);
          InstaService.getUsername(data)
            .then((response) => {
              var dataInstagram = response.data.output;
              this.addNewInstagramData(dataInstagram);
            })
            .catch((err) => {
              this.addInstagramRapid();
              console.log(err);
            });
        }
      });
    },

    addInstagramRapid(username) {
      this.loading = true;
      this.searchResult = [];
      var user = username;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_userinfo.x_rapidapi_host,
        "x-rapidapi-key": this.pref_userinfo.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(this.pref_userinfo.api_host + "?username=" + user, {
          headers: headers,
        })
        .then((response) => {
          var val = response.data;

          let data = {
            pk: val.id,
            username: val.username,
            full_name: val.full_name,
            biography: val.biography,
            following_count: val.edge_follow.count,
            follower_count: val.edge_followed_by.count,
            media_count: val.edge_owner_to_timeline_media.count,
            is_private: val.is_private,
            is_verified: val.is_verified,
            is_business: val.is_business_account,
            picture: val.profile_pic_url,
            picture_hd: val.profile_pic_url_hd,
            public_email: val.business_email,
            contact_phone_number: val.business_phone_number,
            bussiness_category_name: val.business_category_name,
            category_name: val.category_name,
          };
          this.addNewInstagramData(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAvatarInstagram(username) {
      // if (this.searchKey != "") {
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.pref_search_instagram_avatar.x_rapidapi_host,
        "x-rapidapi-key": this.pref_search_instagram_avatar.x_rapidapi_key,
      };
      // console.log(headers);
      return axios
        .get(
          this.pref_search_instagram_avatar.api_host +
            "?url=https://www.instagram.com/" +
            username +
            "/",
          { headers: headers }
        )
        .then((response) => {
          // console.log('avatar', response.data.data.image);
          this.avatar_instagram = response.data.data.image;
        })
        .catch((err) => {
          console.log(err);
          //   }
        });
      // }
    },

    addNewInstagramData(dataInstagram) {
      Swal.showLoading();
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var data_ig = {
        id_target: this.id,
        user_id: dataInstagram.pk,
        account: dataInstagram.username,
        full_name: dataInstagram.full_name,
        bio: dataInstagram.biography,
        following: dataInstagram.following_count,
        followers: dataInstagram.follower_count,
        media: dataInstagram.media_count,
        is_private: dataInstagram.is_private,
        is_verified: dataInstagram.is_verified,
        is_business: dataInstagram.is_business,
        picture: this.avatar_instagram,
        picture_hd: dataInstagram.image_name,
        public_email: dataInstagram.public_email,
        contact_phone_number: dataInstagram.contact_phone_number,
        bussines_category_name: dataInstagram.business_category_name,
        category_name: dataInstagram.category_name,
        updated_at: time,
      };
      SocmedService.createInstagram(data_ig)
        .then((response) => {
          if (response.status == 212) {
            Swal.fire("Instagram is Updated", "", "success");
          } else {
            Swal.fire(this.$t("alert.alert-save"), "", "success");
          }
          this.loading = false;
          this.getTargetDetail();
          this.addInstagramHide();
          this.addInstagramSearchHide();
          this.listInstagram();
          this.loadingsearchinstagram = false;
          this.searchInstagram = false;
          this.searchKeyInstagram = "";
          this.searchResultInstagram = [];
          this.totalResult = 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    removeSpace(value) {
      let str = value.replace(/\s/g, "");
      return str;
    },

    clearData() {
      this.searchKeyInstagram = "";
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDateSave(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    acceptNumber(value) {
      let x = value[0];
      if (x == 0) {
        let hasil = x.replace("0", "62");
        let number = value.slice(1, 15);
        return (this.private_data_add.phone = hasil + number);
      }
    },

    refreshSlider() {
      this.$refs.slidescore.refresh();
    },

    acceptNumberTele(value) {
      let x = value[0];
      if (x == 0) {
        let hasil = x.replace("0", "62");
        let number = value.slice(1, 15);
        return (this.telegram_add.phone = hasil + number);
      }
    },

    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getRelatedFamily();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toFixed(value) {
      return value.toFixed(0);
    },
  },

  beforeMount() {
    this.getTargetDetail();
    this.getPreferences();
    this.listProfile();
    this.listUser();
  },
  mounted() {
    this.getPreferences();
    this.getPreferencesSearch();
    this.getPreferencesUserInfo();
    this.getPreferencesAvatarInstagram();
    this.getBreach();
    this.getCategory();
    this.listTwitter();
    this.listInstagram();
    this.totalRows = this.items.length;
    // console.log('Log ask => ', this.related_family);
  },
};
</script>
<style>
.custom-scroll::-webkit-scrollbar {
  width: 0px;
}
.xbadge {
  border-radius: 0%;
}
</style>
